const toCompetencies = (labels) => labels.map((label, i) => ({ index: i + 1, label }));

export const MTKLANGUAGE_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "part_1_knowing_who_we_are_and_our_families",
         "label": "Knowing who we are and our families",
         "start": 1,
         "count": 7,
         "mean": 6.3,
         "stdDev": 1.22,
         "ranges": [
            [0, 5.68, "Beginner"],
            [5.69, 6.91, "Basic"],
            [6.92, 7, "Competent"]
         ]
      },
      {
         "key": "part_2_exploring_my_community",
         "label": "Exploring my Community",
         "start": 8,
         "count": 6,
         "mean": 5.37,
         "stdDev": 0.8,
         "ranges": [
            [0, 4.96, "Beginner"],
            [4.97, 5.77, "Basic"],
            [5.78, 6, "Competent"]
         ]
      },
      {
         "key": "part_3_appreciating_our_country",
         "label": "Appreciating our Country",
         "start": 14,
         "count": 4,
         "mean": 2.92,
         "stdDev": 1.02,
         "ranges": [
            [0, 2.4, "Beginner"],
            [2.41, 3.43, "Basic"],
            [3.44, 4, "Competent"]
         ]
      },
      {
         "key": "part_4_caring_for_the_world",
         "label": "Caring for the World",
         "start": 18,
         "count": 3,
         "mean": 2,
         "stdDev": 0.92,
         "ranges": [
            [0, 1.53, "Beginner"],
            [1.54, 2.46, "Basic"],
            [2.47, 23, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,15.3,"Beginner"],[15.31,18.17,"Basic"],[18.18,20,"Competent"]],
   totalSummary: {"count":20,"mean":16.73,"stdDev":2.87},
   sections: [
      {
         "label": "Part 1: Knowing who we are and our families",
         "start": 1,
         "end": 7
      },
      {
         "label": "Part 2: Exploring my community",
         "start": 8,
         "end": 13
      },
      {
         "label": "Part 3: Appreciating our Country",
         "start": 14,
         "end": 17
      },
      {
         "label": "Part 4: Caring for the World",
         "start": 18,
         "end": 20
      }
   ],
   competencies: toCompetencies([
      "Identify one’s given name, friends' names, their family members, and common things they use that are found at home;",
      "Produce the sound of the letter it stands for",
      "Produce the sound of the letter it stands for",
      "Write the letters of the alphabet in uppercase and lowercase form",
      "Write the letters of the alphabet in uppercase and lowercase form",
      "Narrate one’s personal experiences",
      "Use polite greetings and courteous expressions in appropriate situations",
      "Recognize that sounding off letters form words",
      "Recognize that sounding off letters form words",
      "Identify familiar sounds in the environment",
      "Describe the different places and persons belonging in one’s community",
      "Give the correct sequence of events in a local text listened to;",
      "Tell the names of the days in a week and months in a year",
      "Participate in dialogues or conversations about familiar events",
      "Identify solutions to a problem based on a local text listened to",
      "Identify solutions to a problem based on a local text listened to",
      "Identify solutions to a problem based on a local text listened to",
      "Predict outcomes based on any given situation;",
      "Predict outcomes based on any given situation;",
      "Predict outcomes based on any given situation;"
   ])
};

export const MTKMATH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "part_1_knowing_who_we_are_and_our_families",
         "label": "Knowing who we are and our families",
         "start": 1,
         "count": 7,
         "mean": 6.3,
         "stdDev": 1.22,
         "ranges": [
            [0, 5.06, "Beginner"],
            [5.07, 6.34, "Basic"],
            [6.35, 8, "Competent"]
         ]
      },
      {
         "key": "part_2_exploring_my_community",
         "label": "Exploring my Community",
         "start": 8,
         "count": 6,
         "mean": 4.3,
         "stdDev": 1.06,
         "ranges": [
            [0, 3.76, "Beginner"],
            [3.77, 5.36, "Basic"],
            [5.37, 6, "Competent"]
         ]
      },
      {
         "key": "part_3_appreciating_our_country",
         "label": "Appreciating our Country",
         "start": 14,
         "count": 5,
         "mean": 4,
         "stdDev": 0.92,
         "ranges": [
            [0, 3.53, "Beginner"],
            [3.54, 4.46, "Basic"],
            [4.47, 5, "Competent"]
         ]
      },
      {
         "key": "part_4_caring_for_the_world",
         "label": "Caring for the World",
         "start": 19,
         "count": 2,
         "mean": 1.55,
         "stdDev": 0.4,
         "ranges": [
            [0, 1.34, "Beginner"],
            [1.35, 1.75, "Basic"],
            [1.76, 2, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,15.39,"Beginner"],[15.4,18.1,"Basic"],[18.11,20,"Competent"]],
   totalSummary: {"count":20,"mean":16.75,"stdDev":2.7},
   sections: [
      {
         "label": "Part 1: Knowing who we are and our families",
         "start": 1,
         "end": 7
      },
      {
         "label": "Part 2: Exploring my community",
         "start": 8,
         "end": 13
      },
      {
         "label": "Part 3: Appreciating our Country",
         "start": 14,
         "end": 18
      },
      {
         "label": "Part 4: Caring for the World",
         "start": 19,
         "end": 20
      }
   ],
   competencies: toCompetencies([
      "Match numerals to a set of concrete objects around me.",
      "Match numerals to a set of concrete objects around me.",
      "Compare quantities using one to one correspondence to determine which has more, less, or equal.",
      "Compare quantities using one to one correspondence to determine which has more, less, or equal.",
      "Compare quantities using one to one correspondence to determine which has more, less, or equal.",
      "Use non-standard measuring tools",
      "Use non-standard measuring tools",
      "Classify common objects in the environment according to colors and shapes.",
      "Classify common objects in the environment according to colors and shapes.",
      "Create own patterns using local concrete objects",
      "Create own patterns using local concrete objects",
      "Identify the positions (in, on, over, under, top, and bottom) and directions (left and right, front and back) of objects in one’s environment.",
      "Identify the positions (in, on, over, under, top, and bottom) and directions (left and right, front and back) of objects in one’s environment.",
      "Apply basic mathematical operations (formal and non-formal applications) using locally available materials.",
      "Apply basic mathematical operations (formal and non-formal applications) using locally available materials.",
      "Apply basic mathematical operations (formal and non-formal applications) using locally available materials.",
      "Recognize Philippine coins and bills and their importance.",
      "Recognize Philippine coins and bills and their importance.",
      "Create visual representations of simple concepts (pictographs, pictures, illustrations, etc.).",
      "Create visual representations of simple concepts (pictographs, pictures, illustrations, etc.)."
   ])
};

export const MTKSCIENCE_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "part_1_knowing_who_we_are_and_our_families",
         "label": "Knowing who we are and our families",
         "start": 1,
         "count": 8,
         "mean": 6.42,
         "stdDev": 1.57,
         "ranges": [
            [0, 5.63, "Beginner"],
            [5.64, 7.21, "Basic"],
            [7.22, 8, "Competent"]
         ]
      },
      {
         "key": "part_2_exploring_my_community",
         "label": "Exploring my Community",
         "start": 9,
         "count": 2,
         "mean": 1.51,
         "stdDev": 0.48,
         "ranges": [
            [0, 1.26, "Beginner"],
            [1.27, 1.75, "Basic"],
            [1.76, 2, "Competent"]
         ]
      },
      {
         "key": "part_3_appreciating_my_country",
         "label": "Appreciating our Country",
         "start": 11,
         "count": 3,
         "mean": 2,
         "stdDev": 0.96,
         "ranges": [
            [0, 1.51, "Beginner"],
            [1.52, 2.48, "Basic"],
            [2.49, 3, "Competent"]
         ]
      },
      {
         "key": "part_4_caring_for_the_world",
         "label": "Caring for the World",
         "start": 14,
         "count": 7,
         "mean": 5.7,
         "stdDev": 1.2,
         "ranges": [
            [0, 5.09, "Beginner"],
            [5.1, 6.3, "Basic"],
            [6.31, 7, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,15.46,"Beginner"],[15.47,18.63,"Basic"],[18.64,20,"Competent"]],
   totalSummary: {"count":20,"mean":17.05,"stdDev":3.16},
   sections: [
      {
         "label": "Part 1: Knowing who we are and our families",
         "start": 1,
         "end": 8
      },
      {
         "label": "Part 2: Exploring my community",
         "start": 9,
         "end": 10
      },
      {
         "label": "Part 3: Appreciating my Country ",
         "start": 11,
         "end": 13
      },
      {
         "label": "Part 4: Caring for the World",
         "start": 14,
         "end": 20
      }
   ],
   competencies: toCompetencies([
      "Identify the body parts and their functions.",
      "Identify the body parts and their functions.",
      "Describe objects based on attributes (shapes, sizes, uses, etc.) using senses and body parts.",
      "Describe objects based on attributes (shapes, sizes, uses, etc.) using senses and body parts.",
      "Practice ways of caring for and protecting one’s body.",
      "Practice ways of caring for and protecting one’s body.",
      "Use communication tools properly and technology appropriately.",
      "Use communication tools properly and technology appropriately.",
      "Recognize different modes of transportation on land, water, and air used in the community.",
      "Recognize different modes of transportation on land, water, and air used in the community.",
      "Appreciate the natural and physical environment in the country.",
      "Appreciate the natural and physical environment in the country.",
      "Appreciate the natural and physical environment in the country.",
      "Observe the changes in the weather daily (temperature, time, etc.).",
      "Observe the changes in the weather daily (temperature, time, etc.).",
      "Classify objects based on observable properties.",
      "Classify objects based on observable properties.",
      "Demonstrate preparedness during emergencies and disasters.",
      "Demonstrate preparedness during emergencies and disasters.",
      "Demonstrate preparedness during emergencies and disasters."
   ])
};

export const MTG1LANGUAGE_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "part_1_language_for_interaction_with_others",
         "label": "Language for interaction with others",
         "start": 1,
         "count": 9,
         "mean": 6.57,
         "stdDev": 2.11,
         "ranges": [
            [0, 5.51, "Beginner"],
            [5.52, 8.68, "Basic"],
            [8.69, 9, "Competent"]
         ]
      },
      {
         "key": "part_2_language_for_developing_and_expressing_ideas",
         "label": "Language for developing and expressing ideas",
         "start": 10,
         "count": 1,
         "mean": 0.5,
         "stdDev": 0.49,
         "ranges": [
            [0, 0.25, "Beginner"],
            [0.26, 0.66, "Basic"],
            [0.67, 1, "Competent"]
         ]
      },
      {
         "key": "part_3_appreciating_language",
         "label": "Appreciating Language",
         "start": 11,
         "count": 8,
         "mean": 5.12,
         "stdDev": 2.19,
         "ranges": [
            [0, 4.02, "Beginner"],
            [4.03, 7.31, "Basic"],
            [7.32, 8, "Competent"]
         ]
      },
      {
         "key": "part_4_interacting_with_text",
         "label": "Interacting with text",
         "start": 19,
         "count": 8,
         "mean": 4.6,
         "stdDev": 1.84,
         "ranges": [
            [0, 3.67, "Beginner"],
            [3.68, 6.44, "Basic"],
            [6.45, 8, "Competent"]
         ]
      },
      {
         "key": "part_5_creating_text",
         "label": "Creating and Composing Text",
         "start": 27,
         "count": 9,
         "mean": 4.83,
         "stdDev": 2.24,
         "ranges": [
            [0, 3.7, "Beginner"],
            [3.71, 7.07, "Basic"],
            [7.08, 9, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,25.8,"Beginner"],[25.81,29.17,"Basic"],[29.18,35,"Competent"]],
   totalSummary: {"count":35,"mean":26.93,"stdDev":2.24},
   sections: [
      {
         "label": "Part 1: Language for interaction with others",
         "start": 1,
         "end": 9
      },
      {
         "label": "Part 2: Language for developing and expressing ideas",
         "start": 10,
         "end": 10
      },
      {
         "label": "Part 3: Appreciating Language",
         "start": 11,
         "end": 18
      },
      {
         "label": "Part 4: Interacting with text",
         "start": 19,
         "end": 26
      },
      {
         "label": "Part 5: Creating Text",
         "start": 27,
         "end": 35
      }
   ],
   competencies: toCompetencies([
      "Use common and socially acceptable expressions: Use simple and appropriate personal greetings.",
      "Use common and socially acceptable expressions: Use familiar terms of address.",
      "Use common and socially acceptable expressions: Greet and respond appropriately to greetings",
      "Interact purposely and participate in conversations and discussions in pairs, in groups, or in whole-class discussion: Make requests",
      "Interact purposely and participate in conversations and discussions in pairs, in groups, or in whole-class discussion: Give or offer information",
      "Interact purposely and participate in conversations and discussions in pairs, in groups, or in whole-class discussion: Communicate needs",
      "Interact purposely and participate in conversations and discussions in pairs, in groups, or in whole-class discussion: Clarify information",
      "Interact purposely and participate in conversations and discussions in pairs, in groups, or in whole-class discussion: Seek help",
      "Interact purposely and participate in conversations and discussions in pairs, in groups, or in whole-class discussion: Take part in or take turns in conversation or discussion",
      "Express ideas using a variety of symbols (e.g., drawings, emojis, scribbles): (a) oneself and family (b) content-specific topics",
      "Use words to represent ideas and events related to oneself and family: words that represent people, animals, objects, locations (naming words)",
      "Use words to represent ideas and events related to oneself and family: words that represent activities and situations (action words)",
      "Use words to represent ideas and events related to oneself and family: words that represent qualities or attributes (describing words)",
      "Use language to express connections between ideas: Express compare and contrast",
      "Use language to express connections between ideas: Express cause and effect",
      "Use language to express connections between ideas: Use time words to relate ideas",
      "Recognize the difference between statements, questions, commands and exclamations.",
      "Respond to change of tones and cues through facial expressions, gestures and actions",
      "Recognize icons and symbols in various texts found in familiar contexts (e.g., printed and digital texts, books, magazines, environmental print).",
      "Engage with or respond to a short spoken texts: Identify a variety of purposes for viewing and listening to texts",
      "Engage with or respond to a short spoken texts: Discuss what is interesting or entertaining in a text",
      "Engage with or respond to a short spoken texts: Express personal preferences",
      "Give reason/s for choosing books/texts for enjoyment and interest.",
      "Record and report ideas and events using some learnt vocabulary: Note and describe main points",
      "Record and report ideas and events using some learnt vocabulary: Sequence up to three (3) key events",
      "Record and report ideas and events using some learnt vocabulary: Relate ideas or events to one’s experience",
      "Use own words in retelling",
      "Draw and discuss information or ideas from a range of text (e.g., stories, images, digital texts): Note and describe main points (e.g., main characters and events)",
      "Draw and discuss information or ideas from a range of text (e.g., stories, images, digital texts): Note and describe main points (e.g., main characters and events)",
      "Draw and discuss information or ideas from a range of text (e.g., stories, images, digital texts): Note and describe main points (e.g., main characters and events)",
      "Draw and discuss information or ideas from a range of text (e.g., stories, images, digital texts): Sequence up to three (3) key events",
      "Draw and discuss information or ideas from a range of text (e.g., stories, images, digital texts): Infer the character’s feelings and traits",
      "Draw and discuss information or ideas from a range of text (e.g., stories, images, digital texts): Note and describe main points (e.g., main characters and events)",
      "Draw and discuss information or ideas from a range of text (e.g., stories, images, digital texts): Predict possible endings",
      "Draw and discuss information or ideas from a range of text (e.g., stories, images, digital texts): Relate ideas or events to one’s experience"
   ])
};

export const MTG1MATH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "part_1_measurement_and_geometry",
         "label": "Measurement and Geometry",
         "start": 1,
         "count": 11,
         "mean": 7.63,
         "stdDev": 2.08,
         "ranges": [
            [0, 6.31, "Beginner"],
            [6.32, 9.44, "Basic"],
            [9.45, 11, "Competent"]
         ]
      },
      {
         "key": "part_2_number_and_algebra",
         "label": "Number and Algebra",
         "start": 12,
         "count": 25,
         "mean": 15.92,
         "stdDev": 5.53,
         "ranges": [
            [0, 13.15, "Beginner"],
            [13.16, 21.45, "Basic"],
            [21.46, 25, "Competent"]
         ]
      },
      {
         "key": "part_3_data_and_probability",
         "label": "Data and Probability",
         "start": 37,
         "count": 4,
         "mean": 2.14,
         "stdDev": 1.22,
         "ranges": [
            [0, 1.52, "Beginner"],
            [1.53, 3.36, "Basic"],
            [3.37, 4, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,23.71,"Beginner"],[23.72,35.6,"Basic"],[35.61,40,"Competent"]],
   totalSummary: {"count":40,"mean":27.68,"stdDev":7.92},
   sections: [
      {
         "label": "Part 1: Measurement and Geometry",
         "start": 1,
         "end": 11
      },
      {
         "label": "Part 2: Number and Algebra",
         "start": 12,
         "end": 36
      },
      {
         "label": "Part 3: Data and probability",
         "start": 37,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Identify simple 2-dimensional shapes (triangle, rectangle, square) of different size and in different orientation.",
      "Compare and distinguish 2-dimensional shapes according to features such as sides and corners",
      "Compose and decompose triangles, squares, and rectangles",
      "Measure the length of an object and the distance between two objects using non-standard units.",
      "Compare lengths and distances using non-standard unit",
      "Solve problems involving lengths and distances using non-standard units",
      "Identify the position of objects moved in half turn or in quarter turn, in clockwise or in counter-clockwise direction, given an initial facing direction.",
      "Read and write time by the hour, half hour, and quarter hour using an analog clock.",
      "Give the days of the week and months of the year in the correct order",
      "Determine the day and month of the year using a calendar.",
      "Solve problems involving time (hour, half hour, quarter hour, days in a week, and months in a year).",
      "Compare two numbers up to 20.",
      "Order numbers up to 20 from smallest to largest, and vice versa.",
      "Describe the position of objects using ordinal numbers: 1st, 2nd, 3rd, up to 10t",
      "Compose and decompose numbers up to 10 using concrete materials (e.g., 5 is 5 and 0; 4 and 1; 3 and 2; 2 and 3; 1 and 4; 0 and 5).",
      "Illustrate addition of numbers with sums up to 20 using a variety of concrete and pictorial models and describes addition as “counting up,” and “putting together.”",
      "Illustrate by applying the following properties of addition, using sums up to 20: a. the sum of zero and any number is equal to the number, and b. changing the order of the addends does not change the sum.",
      "Solve problems (given orally or in pictures) involving addition with sums up to 20",
      "Order numbers up to 100 from smallest to largest, and vice versa.",
      "Counts by 2s, 5s and 10s up to 100.",
      "Determine (a.) the place value of a digit in a 2-digit number, (b.) the value of a digit, and (c.) the digit of a number, given its place value",
      "Decompose any 2-digit number into tens and ones.",
      "Add numbers by expressing addends as tens and ones (expanded form).",
      "Add numbers with sums up to 100 without regrouping, using a variety of concrete and pictorial models for: a. 2-digit and 1-digit numbers, and b. 2-digit and 2-digit numbers.",
      "Solve problems (given orally or in pictures) involving addition with sums up to 100 without regrouping",
      "Illustrate subtraction involving numbers up to 20 using a variety of concrete and pictorial models, and describes subtraction as “taking away.”",
      "Find the missing number in addition or subtraction sentences involving numbers up to 20",
      "Write an equivalent expression to a given addition or subtraction expression (e.g., 2+3 = 1+4; 10-5 = 6-1).",
      "Solve subtraction problems (given orally or in pictures) where both numbers are less than 20.",
      "Subtract numbers where both numbers are less than 100 using concrete and pictorial models, without regrouping: a. 2-digit minus 1-digit numbers, and b. 2-digit minus 2-digit numbers.",
      "Determine the next term/s in a repeating pattern (patterns could use rhythmic properties, visual elements in the arts, …)",
      "Determine the next term/s in a repeating pattern (patterns could use rhythmic properties, visual elements in the arts, …)",
      "Compare 1/2 and 1/4 using models.",
      "Determine the value of a number of bills and/or a number of coins (excluding centavo coins) up to ₱100.",
      "Compare different denominations of peso coins (excluding centavo coins) and bills up to ₱100",
      "Solve 1-step problems (given orally or in pictures) involving addition of money where the sum is up to ₱100, or subtraction of money where both amounts are less than ₱10",
      "Collect data in one variable through a simple interview.",
      "Present data in a pictograph without a scale",
      "Interpret a pictograph without a scale.",
      "Organize data in a pictograph without a scale into a table."
   ])
};

export const MTG1RAL_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "part_1_phonological_awareness",
         "label": "Phonological Awareness",
         "start": 1,
         "count": 4,
         "mean": 3.15,
         "stdDev": 0.84,
         "ranges": [
            [0, 2.72, "Beginner"],
            [2.73, 3.57, "Basic"],
            [3.58, 4, "Competent"]
         ]
      },
      {
         "key": "part_2_phonics",
         "label": "Phonics",
         "start": 5,
         "count": 4,
         "mean": 2.86,
         "stdDev": 1.06,
         "ranges": [
            [0, 2.32, "Beginner"],
            [2.33, 3.39, "Basic"],
            [3.4, 4, "Competent"]
         ]
      },
      {
         "key": "part_3_vocabulary",
         "label": "Vocabulary",
         "start": 9,
         "count": 6,
         "mean": 4.34,
         "stdDev": 1.78,
         "ranges": [
            [0, 3.44, "Beginner"],
            [3.45, 5.23, "Basic"],
            [5.24, 6, "Competent"]
         ]
      },
      {
         "key": "part_4_book_and_print_knowledge",
         "label": "Book and Print Knowledge",
         "start": 15,
         "count": 4,
         "mean": 3.05,
         "stdDev": 1.11,
         "ranges": [
            [0, 2.49, "Beginner"],
            [2.5, 3.61, "Basic"],
            [3.62, 4, "Competent"]
         ]
      },
      {
         "key": "part_5_comprehending_and_analyzing",
         "label": "Comprehending and Analyzing",
         "start": 19,
         "count": 14,
         "mean": 7.58,
         "stdDev": 3.07,
         "ranges": [
            [0, 6.04, "Beginner"],
            [6.05, 10.65, "Basic"],
            [10.66, 14, "Competent"]
         ]
      },
      {
         "key": "part_6_creating_and_composing_text",
         "label": "Creating and Composing Text",
         "start": 33,
         "count": 3,
         "mean": 1.46,
         "stdDev": 1.09,
         "ranges": [
            [0, 0.95, "Beginner"],
            [0.96, 2.46, "Basic"],
            [2.47, 3, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,19.01,"Beginner"],[19.02,29.94,"Basic"],[29.95,35,"Competent"]],
   totalSummary: {"count":35,"mean":22.66,"stdDev":7.28},
   sections: [
      {
         "label": "Part 1: Phonological Awareness",
         "start": 1,
         "end": 4
      },
      {
         "label": "Part 2: Phonics",
         "start": 5,
         "end": 8
      },
      {
         "label": "Part 3: Vocabulary",
         "start": 9,
         "end": 14
      },
      {
         "label": "Part 4: Book and Print Knowledge",
         "start": 15,
         "end": 18
      },
      {
         "label": "Part 5: Comprehending and Analyzing",
         "start": 19,
         "end": 32
      },
      {
         "label": "Part 6: Creating and Composing Text",
         "start": 33,
         "end": 35
      }
   ],
   competencies: toCompetencies([
      "Identify rhyming words in nursery rhymes, poems, and chants.",
      "Identify rhyming words in nursery rhymes, poems, and chants.",
      "Identify initial sounds (vowels, consonants, and semi-vowels, if any).",
      "Identify initial sounds (vowels, consonants, and semi-vowels, if any).",
      "Identify the letters in L1.",
      "Identify the letters in L1.",
      "Isolate sounds (consonants and vowels) in a word (beginning and/or ending).",
      "Isolate sounds (consonants and vowels) in a word (beginning and/or ending).",
      "Use vocabulary referring to oneself and family.",
      "Use vocabulary referring to oneself and family.",
      "Identify words with different functions (naming and describing words): words that label persons, places, things, animals, actions, situations, ideas, and emotions.",
      "Identify words with different functions (naming and describing words): words that label persons, places, things, animals, actions, situations, ideas, and emotions.",
      "Read content-specific words (Math, SiKaP, GMRC) accurately for meaning.",
      "Read content-specific words (Math, SiKaP, GMRC) accurately for meaning.",
      "Recognize environmental print (symbols).",
      "Recognize environmental print (symbols).",
      "Recognize the parts of the book (cover page, title page, etc.).",
      "Recognize the parts of the book (cover page, title page, etc.).",
      "Note important details in stories (character, setting,).",
      "Note important details in stories (events).",
      "Sequence stories with at least 3 even.",
      "Infer the character’s feelings and traits.",
      "Predict possible ending.",
      "Note important details in stories (character, setting,).",
      "Note important details in stories (events).",
      "Note important details in stories (events).",
      "Infer the character’s feelings and traits.",
      "Predict possible ending.",
      "Note significant details in informational texts (list and describe).",
      "Identify problem and solution.",
      "Note significant details in informational texts (list and describe).",
      "Identify problem and solution.",
      "Narrate one’s personal experiences:  (a) oneself and family.",
      "Narrate one’s personal experiences:  (b) content-specific topics.",
      "Use own words in retelling myths, legends, fables, and narrative poems."
   ])
};

export const MTG2ENGLISH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_phonological_awareness",
         "label": "Phonological Awareness",
         "start": 1,
         "count": 4,
         "mean": 2.98,
         "stdDev": 0.8,
         "ranges": [
            [0, 2.57, "Beginner"],
            [2.58, 2.98, "Basic"],
            [2.99, 4, "Competent"]
         ]
      },
      {
         "key": "b_phonics_and_word_study",
         "label": "Phonics and Word Study",
         "start": 5,
         "count": 4,
         "mean": 2.66,
         "stdDev": 0.06,
         "ranges": [
            [0, 2.22, "Beginner"],
            [2.23, 2.66, "Basic"],
            [2.67, 4, "Competent"]
         ]
      },
      {
         "key": "c_vocabulary",
         "label": "Vocabulary",
         "start": 9,
         "count": 7,
         "mean": 5.79,
         "stdDev": 1.55,
         "ranges": [
            [0, 4.5, "Beginner"],
            [4.51, 5.29, "Basic"],
            [5.3, 7, "Competent"]
         ]
      },
      {
         "key": "d_grammatical_structure",
         "label": "Grammatical Structure",
         "start": 16,
         "count": 10,
         "mean": 7.58,
         "stdDev": 2.06,
         "ranges": [
            [0, 6.54, "Beginner"],
            [6.55, 7.58, "Basic"],
            [7.59, 10, "Competent"]
         ]
      },
      {
         "key": "e_comprehending_and_analyzing_text",
         "label": "Comprehending and Analyzing Text",
         "start": 26,
         "count": 12,
         "mean": 10.08,
         "stdDev": 1.83,
         "ranges": [
            [0, 9.16, "Beginner"],
            [9.17, 10.08, "Basic"],
            [10.09, 12, "Competent"]
         ]
      },
      {
         "key": "f_creating_and_composing_text",
         "label": " Creating and Composing Text",
         "start": 38,
         "count": 8,
         "mean": 5.45,
         "stdDev": 1.97,
         "ranges": [
            [0, 4.46, "Beginner"],
            [4.47, 5.45, "Basic"],
            [5.46, 8, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,30.97,"Beginner"],[30.98,34.54,"Basic"],[34.55,45,"Competent"]],
   totalSummary: {"count":45,"mean":34.54,"stdDev":7.13},
   sections: [
      {
         "label": "A. Phonological Awareness",
         "start": 1,
         "end": 4
      },
      {
         "label": "B.  Phonics and Word Study",
         "start": 5,
         "end": 8
      },
      {
         "label": "C. Vocabulary",
         "start": 9,
         "end": 15
      },
      {
         "label": "D. Grammatical Structure",
         "start": 16,
         "end": 25
      },
      {
         "label": "E. Comprehending and Analyzing Text",
         "start": 26,
         "end": 37
      },
      {
         "label": "F. Creating and Composing Text",
         "start": 38,
         "end": 45
      }
   ],
   competencies: toCompetencies([
      "Recognize rhymes in chants, poems, and stories heard",
      "Recognize rhymes in chants, poems, and stories heard",
      "Segment onset and rime",
      "Segment onset and rime",
      "Read words accurately and automatically according to word patterns (initial, final, medial): CVCe words",
      "medial): CVVC words",
      "Read words accurately and automatically according to word patterns (initial, final, medial): CVCC words",
      "Read words accurately and automatically according to word patterns (initial, final, medial): CCVC words (clusters and diphthongs)",
      "Use vocabulary referring to: physical environment",
      "Use content-specific words: Science (basic terminologies",
      "Identify words with different functions: words that label persons, places, things, animals, events, ideas, and emotions (naming words - nouns)",
      "Identify words with different functions: words that label actions (doing words - verbs)",
      "Identify words with different functions: words that describe persons, places, things, animals, events, ideas, and emotions (describing words - adjectives)",
      "Identify the synonyms and antonyms of words",
      "Identify the synonyms and antonyms of words",
      "Identify sentences and non-sentences.",
      "Use simple sentences to express ideas about environment",
      "Use simple sentences with proper intonation (pitch, juncture, rhythm).",
      "Sequence words to represent meaning in simple sentences: telling sentences (declarative)",
      "Sequence words to represent meaning in simple sentences: commanding and requesting sentences (imperative)",
      "Identify the parts of simple sentences: (who/what, what are they doing, when/where/how): telling sentences (declarative)",
      "Use correct capitalization and punctuation for simple sentences: asking sentences (interrogative)",
      "Use correct capitalization and punctuation for simple sentences: commanding and requesting sentences (imperative)",
      "Identify discourse markers for a given text type: time order and procedural",
      "Identify discourse markers for a given text type: description",
      "Sequence at least three events.",
      "Sequence at least four events.",
      "Note important elements from stories (characters).",
      "Note important elements from stories (setting).",
      "Note important elements from stories (setting).",
      "Identify the problem and solution in stories.",
      "Infer the character’s feelings and traits.",
      "Relate story events to one’s experience.",
      "Predict possible ending.",
      "Identify problem and solution",
      "Identify text types: Explanation",
      "Draw conclusions",
      "Use common expressions and polite greetings appropriate to a given situation.",
      "Use own words in retelling myths, legends, fables, and narrative, poems.",
      "Express ideas about one’s experiences: physical environment",
      "Express ideas about one’s experiences: content-specific topics",
      "Use basic sight words, high frequency, and content-specific words",
      "Compose texts to react to the character, setting, or events in a story.",
      "Compose texts to react to a topic.",
      "Express ideas using text types: time order and procedural."
   ])
};

export const MTG2MATH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_number_and_algebra",
         "label": "Number and Algebra",
         "start": 1,
         "count": 20,
         "mean": 15.58,
         "stdDev": 3.41,
         "ranges": [
            [0, 9.17, "Beginner"],
            [9.18, 18.88, "Basic"],
            [18.89, 20, "Competent"]
         ]
      },
      {
         "key": "b_measurement_and_geometry",
         "label": "Measurement and Geometry",
         "start": 21,
         "count": 10,
         "mean": 6.45,
         "stdDev": 2.35,
         "ranges": [
            [0, 4.28, "Beginner"],
            [4.29, 7.46, "Basic"],
            [7.47, 10, "Competent"]
         ]
      },
      {
         "key": "c_data_and_probability",
         "label": "Data and Probability",
         "start": 31,
         "count": 10,
         "mean": 7.25,
         "stdDev": 2.13,
         "ranges": [
            [0, 6.18, "Beginner"],
            [6.19, 7.25, "Basic"],
            [7.26, 10, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,24.01,"Beginner"],[24.02,27.29,"Basic"],[27.3,40,"Competent"]],
   totalSummary: {"count":40,"mean":27.29,"stdDev":6.55},
   sections: [
      {
         "label": "A. Number and Algebra",
         "start": 1,
         "end": 20
      },
      {
         "label": "B. Measurement and Geometry",
         "start": 21,
         "end": 30
      },
      {
         "label": "C. Data and probability",
         "start": 31,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Read and write numerals up to 1000.",
      "Order numbers up to 1000 from smallest to largest, and vice versa.",
      "Illustrate addition of 2-digit and by 1-digit numbers as “counting up” on the number line.",
      "Add numbers with sums up to 1000, with or without regrouping.",
      "Compare the values of different denominations of peso coins and bills up to ₱1000.",
      "Solve problems involving addition with sums up to 1000, including problems involving money, with and without regrouping",
      "Illustrate subtraction of 2-digit by 1-digit on the number line and as an inverse of addition.",
      "Subtract numbers where both numbers are less than 100 with regrouping: a. 2-digit minus 1-digit numbers.",
      "Subtract numbers where both numbers are less than 100 with regrouping: b. 2-digit minus 2-digit numbers.",
      "Solve problems (given orally or in pictures) involving subtraction where both numbers are less than 100, with and without regrouping.",
      "Subtract numbers, where both numbers are less than 1000, with and without regrouping.",
      "Solve 1- and 2-step problems involving subtraction where both numbers are less than 1000 (including problems involving money), with and without regrouping.",
      "Determine the next term/s in increasing or decreasing patterns, e.g., numbers, letters and rhythmic properties, visual elements in arts, and repetitions.",
      "Multiply numbers using the 2, 3, 4, 5, and 10 multiplication tables.",
      "Solve multiplication problems using the 2, 3, 4, 5, and 10 multiplication tables, including problems involving money.",
      "Divide numbers using the 2, 3 4, 5, and 10 multiplication tables.",
      "Find the missing number in a number sentence involving multiplication or division by 2, 3, 4, 5, and 10.",
      "Solve division problems using the 2, 3, 4, 5, and 10 multiplication tables, including problems involving money.",
      "Represent and identify unit fractions with denominators 2, 3, 4, 5, 6, and 8.",
      "Order unit fractions from smallest to largest, and vice versa.",
      "Represent and describe circles, half circles and quarter circles.",
      "Compose and decompose composite figures made up of squares, rectangles, triangles, circles, half circles, and quarter circles, using cut-outs and square grids.",
      "Measure and compare lengths of objects, in meters (m) or centimeters (cm), and distance in meters, using appropriate measuring tools.",
      "Identify and use the appropriate unit (m or cm) to measure the length of an object and the distance between two locations",
      "Solve problems involving length and distance.",
      "Describe the duration of an event in terms of number of days and/or weeks using a calendar.",
      "Read and write time in hours and minutes, with a.m. and p.m., using an analog clock.",
      "Solve problems involving elapsed time (minutes in an hour, hours in a day, days in a week), including timetables.",
      "Find the perimeter of triangles, squares, and rectangles.",
      "Solve problems involving perimeter of triangles, squares, and rectangles.",
      "Present raw data, or data in tabular form, in a pictograph with a scale, or vice versa.",
      "Present raw data, or data in tabular form, in a pictograph with a scale, or vice versa.",
      "Present raw data, or data in tabular form, in a pictograph with a scale, or vice versa.",
      "Present raw data, or data in tabular form, in a pictograph with a scale, or vice versa.",
      "Present raw data, or data in tabular form, in a pictograph with a scale, or vice versa.",
      "Interpret data in tabular form and in a pictograph with or without scale.",
      "Interpret data in tabular form and in a pictograph with or without scale.",
      "Interpret data in tabular form and in a pictograph with or without scale.",
      "Interpret data in tabular form and in a pictograph with or without scale.",
      "Interpret data in tabular form and in a pictograph with or without scale."
   ])
};

export const MTG3ENGLISH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_vocabulary_and_word_knowledge",
         "label": "Vocabulary and Word Knowledge",
         "start": 1,
         "count": 7,
         "mean": 3.5,
         "stdDev": 1.75,
         "ranges": [
            [0, 2.62, "Beginner"],
            [2.63, 4.38, "Basic"],
            [4.39, 7, "Competent"]
         ]
      },
      {
         "key": "b_grammatical_awareness_and_structure",
         "label": "Grammar Awareness and Structure",
         "start": 8,
         "count": 10,
         "mean": 6.5,
         "stdDev": 4.91,
         "ranges": [
            [0, 4.04, "Beginner"],
            [4.05, 8.96, "Basic"],
            [8.97, 10, "Competent"]
         ]
      },
      {
         "key": "c_comprehension_and_analyzing_text",
         "label": "Comprehending and Analyzing Text",
         "start": 18,
         "count": 14,
         "mean": 9.63,
         "stdDev": 1.02,
         "ranges": [
            [0, 9.11, "Beginner"],
            [9.12, 10.14, "Basic"],
            [10.15, 14, "Competent"]
         ]
      },
      {
         "key": "d_creating_and_composing_text",
         "label": "Creating and Composing Text",
         "start": 32,
         "count": 9,
         "mean": 6.88,
         "stdDev": 1.71,
         "ranges": [
            [0, 6.02, "Beginner"],
            [6.03, 7.74, "Basic"],
            [7.75, 9, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,22.07,"Beginner"],[22.08,33,"Basic"],[33.01,40,"Competent"]],
   totalSummary: {"count":40,"mean":28.06,"stdDev":8.64},
   sections: [
      {
         "label": "A. Vocabulary and Word Knowledge",
         "start": 1,
         "end": 7
      },
      {
         "label": "B. Grammatical Awareness and Structure",
         "start": 8,
         "end": 17
      },
      {
         "label": "C. Comprehension and Analyzing Text",
         "start": 18,
         "end": 31
      },
      {
         "label": "D. Creating and Composing Text",
         "start": 32,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Use vocabulary referring to: national themes.",
      "Use content-specific words: Mathematics",
      "Identify words with different functions: words that label actions (doing words - verbs)",
      "Identify words with different functions: words that describe persons, places, things, animals, events, ideas, and emotions (describing words - adjectives)",
      "Identify the synonyms and antonyms of words.",
      "Identify the synonyms and antonyms of words.",
      "Identify roots of high frequency words (nouns, verbs, and adjectives).",
      "Identify sentences and non-sentences.",
      "Sequence words to represent meaning in simple sentences: telling sentences (declarative)",
      "Sequence words to represent meaning in simple sentences: commanding and requesting sentences (imperative)",
      "Identify the parts of simple sentences: (who/what, what are they doing, when/where/how): telling sentences (declarative)",
      "Identify the parts of simple sentences: (who/what, what are they doing,",
      "when/where/how): telling sentences (declarative)",
      "Use correct capitalization and punctuation for simple sentences: asking sentences (interrogative)",
      "Use correct capitalization and punctuation for simple sentences: exclamatory sentences",
      "Identify in a compound sentence: the two independent clauses in a compound sentence",
      "Identify in a compound sentence: the joining word in a compound sentence (coordinating conjunction)",
      "Note important elements from stories (characters, setting, events).",
      "Sequence at least five events.",
      "Identify the problem and solution in stories.",
      "Infer the character’s feelings and traits",
      "Relate story events to one’s experience.",
      "Identify cause and effect of event",
      "Predict possible ending.",
      "Give a summary",
      "Note at least five significant details in informational texts.",
      "Note at least five significant details in informational texts.",
      "Identify problem and solution.",
      "Identify text types: Description",
      "Identify text types: Explanation",
      "Draw conclusions.",
      "Use common expressions and polite greetings appropriate to a given situation.",
      "Use own words in retelling myths, legends, fables, and narrative poems.",
      "Express ideas about one’s experiences: content-specific topics",
      "Use basic sight words, high frequency, and content-specific words.",
      "Compose texts to react to the character, setting, or events in a story.",
      "Compose texts to react to a topic.",
      "Make a summary of narrative text.",
      "Express ideas using text types: Time order",
      "Express ideas using text types: Explanation"
   ])
};

export const MTG3MATH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_measurement_and_geometry",
         "label": "Measurement and Geometry",
         "start": 1,
         "count": 14,
         "mean": 10.94,
         "stdDev": 4.33,
         "ranges": [
            [0, 8.77, "Beginner"],
            [8.78, 13.11, "Basic"],
            [13.12, 14, "Competent"]
         ]
      },
      {
         "key": "b_number_and_algebra",
         "label": "Number and Algebra",
         "start": 15,
         "count": 17,
         "mean": 10.75,
         "stdDev": 1.13,
         "ranges": [
            [0, 10.18, "Beginner"],
            [10.19, 11.32, "Basic"],
            [11.33, 17, "Competent"]
         ]
      },
      {
         "key": "c_data_and_probability",
         "label": "Data and Probability",
         "start": 32,
         "count": 9,
         "mean": 6.25,
         "stdDev": 0.45,
         "ranges": [
            [0, 6.03, "Beginner"],
            [6.04, 6.48, "Basic"],
            [6.49, 9, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,19.55,"Beginner"],[19.56,25.32,"Basic"],[25.33,40,"Competent"]],
   totalSummary: {"count":40,"mean":22.44,"stdDev":5.76},
   sections: [
      {
         "label": "A. Measurement and Geometry",
         "start": 1,
         "end": 14
      },
      {
         "label": "B. Number and Algebra",
         "start": 15,
         "end": 31
      },
      {
         "label": "C. Data and Probability",
         "start": 32,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Explore inductively the derivation of the formulas for the areas of a square and a rectangle using square tile units",
      "Illustrate and estimate the area of a square or rectangle using square tile units.",
      "Find the areas of squares and rectangles in sq. cm and sq. m.",
      "Solve problems involving areas of squares and rectangles.",
      "Recognize, using models, and draws a point, line, line segment, and ray.",
      "Recognize and draw parallel, intersecting, and perpendicular lines",
      "Identify and draw line segments of equal length using a ruler",
      "Measure mass in grams (g), kilograms (kg) and/or milligrams (mg), using appropriate measuring tools",
      "Compare masses of objects including the use of a balance scale.",
      "Measure capacity in liters (L) and/or milliliters (mL), using appropriate measuring tools",
      "Compare capacities of two containers",
      "Describe and draw the effect of a two-direction multi-step slide (or translation) in basic shapes and figures",
      "Identify shapes or figures that show line symmetry by drawing the line of symmetry.",
      "Complete a figure that is symmetric with respect to a line.",
      "Determine the digit of number, given its place value in a 4-digit number.",
      "Compare numbers up to 10 000 using the symbols =, >, and <.",
      "Order numbers up to 10 000 from smallest to largest, and vice versa",
      "Read and write money in words and using: Philippine currency symbols (₱ and PhP) up to ₱10 000,  with centavo",
      "Add numbers with sums up to 10 000, with and without regrouping.",
      "Solve problems involving addition of numbers with sums up to 10 000, including problems involving money.",
      "Subtract numbers, where both numbers are less than 10 000, with and without regrouping.",
      "Perform addition and subtraction of 3 to 4 numbers of up to 2 digits, observing correct order of operations",
      "Solve problems involving addition and subtraction with 3 to 4 numbers of up to 2 digits, including problems involving money",
      "Multiply numbers using the 6, 7, 8, and 9 multiplication tables.",
      "Multiply numbers with and without regrouping: 2- to 3-digit numbers by a 1-digit number",
      "Solve 1-to 2-step multiplication problems, including problems involving money",
      "Divide numbers using the 6, 7, 8, and 9 multiplication tables.",
      "Find the missing number in a number sentence involving multiplication or division by 6, 7, 8, and 9 (e.g., __ x 7 = 56; 56 ÷ __ = 7).",
      "Solve division problems involving 2- to 3 -digit numbers by a 1-digit number, including problems involving money.",
      "Represent fractions that are equal to one and greater than one using models.",
      "Add and subtract similar fractions using models",
      "Collect data from experiments with a small number of possible outcomes (e.g., rolling a die or tossing a coin).",
      "Present data in tables and single bar graphs (horizontal and vertical).",
      "Present data in tables and single bar graphs (horizontal and vertical).",
      "Interpret data in tables and single bar graphs (horizontal and vertical).",
      "Interpret data in tables and single bar graphs (horizontal and vertical).",
      "Interpret data in tables and single bar graphs (horizontal and vertical).",
      "Solve problems using data presented in a single bar graph (horizontal and vertical).",
      "Solve problems using data presented in a single bar graph (horizontal and vertical).",
      "Describe and compare outcomes in real-life situations using the following terms: equally"
   ])
};

export const MTG3SCIENCE_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_materials",
         "label": "Matter",
         "start": 1,
         "count": 10,
         "mean": 6.19,
         "stdDev": 1.17,
         "ranges": [
            [0, 5.6, "Beginner"],
            [5.61, 6.78, "Basic"],
            [6.7, 10, "Competent"]
         ]
      },
      {
         "key": "b_living_things",
         "label": "Living Things",
         "start": 11,
         "count": 10,
         "mean": 6.13,
         "stdDev": 6.44,
         "ranges": [
            [0, 2.9, "Beginner"],
            [2.91, 9.35, "Basic"],
            [9.36, 10, "Competent"]
         ]
      },
      {
         "key": "c_force_motion_and_energy",
         "label": "Force, Motion, and Energy",
         "start": 21,
         "count": 10,
         "mean": 6.94,
         "stdDev": 2.24,
         "ranges": [
            [0, 5.81, "Beginner"],
            [5.82, 8.06, "Basic"],
            [8.07, 10, "Competent"]
         ]
      },
      {
         "key": "d_earth_and_space",
         "label": "Earth and Space",
         "start": 31,
         "count": 10,
         "mean": 6.38,
         "stdDev": 1.93,
         "ranges": [
            [0, 5.41, "Beginner"],
            [5.42, 7.35, "Basic"],
            [7.36, 10, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,18.81,"Beginner"],[18.82,28.44,"Basic"],[28.45,40,"Competent"]],
   totalSummary: {"count":40,"mean":23.63,"stdDev":9.62},
   sections: [
      {
         "label": "A. Materials",
         "start": 1,
         "end": 10
      },
      {
         "label": "B. Living Things",
         "start": 11,
         "end": 20
      },
      {
         "label": "C. Force, Motion, and Energy",
         "start": 21,
         "end": 30
      },
      {
         "label": "D. Earth and Space",
         "start": 31,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Identify objects, activities, or natural events observed in their local environment that can be explained by science",
      "Participate in guided science activities by asking questions and tinkering with materials;",
      "Describe the uses of various science equipment and materials used in simple activities, such as a ruler, hand lens, scissors, balloons, modeling clay, and cardboard",
      "Describe different science process skills used in performing simple science activities, such as observing, predicting, and measuring using units such as millimeter, centimeter, and meter",
      "Describe the physical properties of solid materials, such as hard, shiny, or stretchable",
      "Explain that changes in materials can be harmful to living and non-living things in the environment, such as trash disposal, and burning household materials",
      "Demonstrate proper handling and disposal of materials according to their properties, such as reusing objects, disposing of excess oil into garbage, and recycling paper, plastic or glass",
      "Describe how changes in solid materials make them useful, such as when they are shaped, pressed, hammered, joined, or cut",
      "Identify the properties and uses of metals used by the local community such as iron, gold, silver, and copper",
      "Identify the properties and uses of metals used by the local community such as iron, gold, silver, and copper",
      "Use the skills of observing, predicting, and measuring in performing simple guided science activities",
      "Observe and describe the difference between living and non-living things and give examples of each that can be found in the local environment",
      "Describe the characteristics of living things: they grow, respond, and reproduce",
      "Observe and describe the outer body parts of animals, such as head, legs or wings, and identify their role to move and to gather food",
      "Observe the outer parts of plants, such as leaves, roots, and stems and identify their role to get water and nutrients from the soil",
      "Observe the outer parts of plants, such as leaves, roots, and stems and identify their role to get water and nutrients from the soil",
      "Identify the basic needs of all living things, such as air, food, water, and shelter",
      "Observe examples and explain how living things depend on one another and on the environment to meet their basic needs",
      "Observe examples and explain how living things depend on one another and on the environment to meet their basic needs",
      "Recognize that there is a need to protect and conserve the environment for living things to survive",
      "Explore and demonstrate different ways to make objects move by natural causes, such as wind and water, or by people, such as pushing, pulling, rolling, and carrying",
      "Explore and describe things that affect the movement of objects, including size, shape, heaviness, material, and surface texture",
      "Measure and describe changes in the position of people or objects in relation to their original position, such as moving closer, farther, left, or right",
      "Explore and describe how sound is made and transferred in everyday situations, such as the ringing of a bell or the hearing of noises",
      "Describe sources of light and their use in everyday situations",
      "Describe sources of light and their use in everyday situations",
      "Participate in guided science activities to explore and describe sources of light, how it behaves or can be changed, and its uses in everyday situations",
      "Explain how light and sound can be harmful to people and make suggestions on how to protect oneself from them",
      "Explain how light and sound can be harmful to people and make suggestions on how to protect oneself from them",
      "Participate in guided activities to explore and describe some ways to use movement, sound, and light to send information between two people.",
      "Participate in guided activities to locate and describe different types of non-living things found in and around their school, such as rocks, soil, water, air, metals, clouds, rain, and sunlight",
      "Identify some useful things that people have made from non-living materials and describe what natural materials have been used to make the items",
      "Recognize that the non-living materials that make up the environment are referred to as earth materials",
      "Observe and record changes in the weather during a day or over some days and describe the different types and patterns of weather that occur in the local area",
      "Describe how changes in the weather can affect daily activities and explain how some types of weather can be dangerous for people",
      "Describe how changes in the weather can affect daily activities and explain how some types of weather can be dangerous for people",
      "Participate in guided activities to carefully observe and describe the natural objects commonly seen in the sky during daytime and nighttime, including the Sun, the Moon, planets, and stars",
      "Participate in guided activities to explore and record how and when the Sun, the Moon, planets, and stars can be seen moving across the sky",
      "Explain how natural objects in the sky affect activities of people",
      "Describe safety measures that people can use to avoid the harmful effects of the Sun’s light."
   ])
};

export const MTG4ENGLISH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "part_1_comprehending_literary_text",
         "label": "Comprehending Literary text",
         "start": 1,
         "count": 19,
         "mean": 8.69,
         "stdDev": 2.18,
         "ranges": [
            [0, 7.59, "Beginner"],
            [7.6, 15.23, "Basic"],
            [15.24, 19, "Competent"]
         ]
      },
      {
         "key": "part_2_comprehending_information",
         "label": "Comprehending information",
         "start": 20,
         "count": 5,
         "mean": 2.67,
         "stdDev": 1.06,
         "ranges": [
            [0, 2.13, "Beginner"],
            [2.14, 4.26, "Basic"],
            [4.27, 5, "Competent"]
         ]
      },
      {
         "key": "part_3_vocabulary",
         "label": "Vocabulary",
         "start": 25,
         "count": 4,
         "mean": 2.9,
         "stdDev": 0.82,
         "ranges": [
            [0, 2.48, "Beginner"],
            [2.49, 3.72, "Basic"],
            [3.73, 4, "Competent"]
         ]
      },
      {
         "key": "part_4_viewing_and_representing",
         "label": "Viewing and representing",
         "start": 29,
         "count": 12,
         "mean": 5.4,
         "stdDev": 0.88,
         "ranges": [
            [0, 4.95, "Beginner"],
            [4.96, 8.04, "Basic"],
            [8.05, 12, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,24.97,"Beginner"],[24.98,31.29,"Basic"],[31.3,40,"Competent"]],
   totalSummary: {"count":40,"mean":27.08,"stdDev":4.21},
   sections: [
      {
         "label": "Part 1: Comprehending Literary text",
         "start": 1,
         "end": 19
      },
      {
         "label": "Part 2: Comprehending Information",
         "start": 20,
         "end": 24
      },
      {
         "label": "Part 3: Vocabulary",
         "start": 25,
         "end": 28
      },
      {
         "label": "Part 4: Viewing and representing",
         "start": 29,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Noting important elements (story grammar)",
      "Noting important elements (story grammar)",
      "Noting important elements (story grammar)",
      "Noting important elements (story grammar)",
      "Identifying  author’s/speaker’s point of view from literary text",
      "Identifying  author’s/speaker’s point of view from literary text",
      "Identifying  author’s/speaker’s point of view from literary text",
      "Identifying  author’s/speaker’s point of view from literary text",
      "Making predictions: outcomes of events",
      "Making predictions: outcomes of events",
      "Making predictions: outcomes of events",
      "Making predictions: outcomes of events",
      "Drawing conclusions from literary texts.",
      "Drawing conclusions from literary texts.",
      "Drawing conclusions from literary texts.",
      "Drawing conclusions from literary texts.",
      "Identifying the main idea from the literary text.",
      "Identifying the main idea from the literary text.",
      "Identifying the main idea from the literary text.",
      "Identifying the text type  through informational texts: (a.) Enumeration, (B.) time order: chronology, (C.) time order: procedural, (D.) recount.",
      "Identifying the text type  through informational texts: (a.) Enumeration, (B.) time order: chronology, (C.) time order: procedural, (D.) recount.",
      "Identifying the text type  through informational texts: (a.) Enumeration, (B.) time order: chronology, (C.) time order: procedural, (D.) recount.",
      "Identifying the text type  through informational texts: (a.) Enumeration, (B.) time order: chronology, (C.) time order: procedural, (D.) recount.",
      "Identifying the author's purpose through informational texts.",
      "Using context clues with literal (denotative) and implied (connotative) meanings in sentences: (a.) Synonyms, (b.) Antonyms, (c.) Definition, (d.)  exemplification",
      "Using context clues with literal (denotative) and implied (connotative) meanings in sentences: (a.) Synonyms, (b.) Antonyms, (c.) Definition, (d.)  exemplification",
      "Using context clues with literal (denotative) and implied (connotative) meanings in sentences: (a.) Synonyms, (b.) Antonyms, (c.) Definition, (d.)  exemplification",
      "Using context clues with literal (denotative) and implied (connotative) meanings in sentences: (a.) Synonyms, (b.) Antonyms, (c.) Definition, (d.)  exemplification",
      "Identify real or make believe, fact or non-fact images.",
      "Identify real or make believe, fact or non-fact images.",
      "Identify multimedia elements: text and graphics",
      "Identify multimedia elements: text and graphics",
      "Identify multimedia elements: text and graphics",
      "Identify multimedia elements: text and graphics",
      "Identify multimedia elements: text and graphics",
      "Identify multimedia elements: text and graphics",
      "Identify multimedia elements: text and graphics",
      "Identify multimedia elements: text and graphics",
      "Identify multimedia elements: text and graphics",
      "Identify multimedia elements: text and graphics"
   ])
};

export const MTG4MATH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "part_1_measurement_and_geometry",
         "label": "Measurement and Geometry",
         "start": 1,
         "count": 5,
         "mean": 5.92,
         "stdDev": 1.72,
         "ranges": [
            [0, 5.05, "Beginner"],
            [5.06, 7.64, "Basic"],
            [7.65, 9, "Competent"]
         ]
      },
      {
         "key": "part_2_number_and_algebra",
         "label": "Number and Algebra",
         "start": 6,
         "count": 12,
         "mean": 19.36,
         "stdDev": 4.63,
         "ranges": [
            [0, 17.04, "Beginner"],
            [17.05, 23.99, "Basic"],
            [24, 28, "Competent"]
         ]
      },
      {
         "key": "part_3_measurement_and_geometry",
         "label": "Data and Probability",
         "start": 18,
         "count": 3,
         "mean": 2.46,
         "stdDev": 0.82,
         "ranges": [
            [0, 2.04, "Beginner"],
            [2.05, 2.87, "Basic"],
            [2.88, 3, "Competent"]
         ]
      },
      {
         "key": "part_4_number_and_algebra",
         "label": "Number and Algebra",
         "start": 21,
         "count": 9,
         "mean": 0,
         "stdDev": 1,
         "ranges": [
            [0, 0, "Beginner"],
            [0, 0, "Basic"],
            [0, 9, "Competent"]
         ]
      },
      {
         "key": "part_5_measurement_and_geometry",
         "label": "Measurement and Geometry",
         "start": 30,
         "count": 1,
         "mean": 0,
         "stdDev": 1,
         "ranges": [
            [0, 0, "Beginner"],
            [0, 0, "Basic"],
            [0, 1, "Competent"]
         ]
      },
      {
         "key": "part_6_data_and_probability",
         "label": "Data and Probability",
         "start": 31,
         "count": 3,
         "mean": 0,
         "stdDev": 1,
         "ranges": [
            [0, 0, "Beginner"],
            [0, 0, "Basic"],
            [0, 3, "Competent"]
         ]
      },
      {
         "key": "part_7_number_and_algebra",
         "label": "Number and Algebra",
         "start": 34,
         "count": 7,
         "mean": 0,
         "stdDev": 1,
         "ranges": [
            [0, 0, "Beginner"],
            [0, 0, "Basic"],
            [0, 7, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,26.18,"Beginner"],[26.19,34.87,"Basic"],[34.88,40,"Competent"]],
   totalSummary: {"count":40,"mean":29.08,"stdDev":5.79},
   sections: [
      {
         "label": "Part 1: Measurement and Geometry",
         "start": 1,
         "end": 5
      },
      {
         "label": "Part 2: Number and Algebra",
         "start": 6,
         "end": 17
      },
      {
         "label": "Part 3: Measurement and Geometry",
         "start": 18,
         "end": 20
      },
      {
         "label": "Part 4: Number and Algebra",
         "start": 21,
         "end": 29
      },
      {
         "label": "Part 5: Measurement and Geometry",
         "start": 30,
         "end": 30
      },
      {
         "label": "Part 6: Data and Probability",
         "start": 31,
         "end": 33
      },
      {
         "label": "Part 7: Number and Algebra",
         "start": 34,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Illustrate different angles (right, acute, and obtuse) using models.",
      "Classify triangles and quadrilaterals according to sides and angles.",
      "Differentiate different quadrilaterals.",
      "Find the perimeter of quadrilaterals that are not squares or rectangles.",
      "Find the perimeter of composite figures composed of triangles and quadrilaterals.",
      "Read and write numbers up to 1 000 000 in numerals and in words.",
      "Determine (a.) the place value of a digit in a 6-digit number, (b.) the value of a digit, and (c.) the digit of number, given its place value.",
      "Determine (a.) the place value of a digit in a 6-digit number, (b.) the value of a digit, and (c.) the digit of number, given its place value.",
      "Compare numbers up to 1 000 000 using =, < and >.",
      "Estimate the sum and difference of two 5- to 6-digit numbers by rounding the addends to the nearest large place value of the numbers.",
      "Add numbers with sums up to 1 000 000 and subtracts numbers where both numbers are less than 1 000 000, with and without regrouping.",
      "Multiply two numbers with and without regrouping: a. 3- to 4-digit numbers by a 1-digit number, and b. 2- to 3-digit numbers by 2-digit numbers, with products up to 1 000 000.",
      "Estimate the result of multiplying two numbers where the product is less than 1 000 000.",
      "Solve multi-step problems involving one or more of the four operations with results of calculations up to 1 000 000, including problems involving money.",
      "Divide two numbers with and without regrouping a. 3- to 4-digit numbers by 1-digit numbers b. 2- to 3-digit numbers by 2-digit numbers",
      "Estimate the quotient when dividing 3- to 4-digit dividends by 1- to 2-digit divisors, by first estimating the dividends and divisors using multiples of 10.",
      "Perform two or more different operations by applying the MDAS rules.",
      "Convert common units of measure from larger to smaller units, and vice versa: a. meter and centimeter, b. kilometer and meter, c. kilogram and gram, d. gram and milligram, and e. liter and milliliter.",
      "Convert common units of measure from larger to smaller units, and vice versa: a. meter and centimeter, b. kilometer and meter, c. kilogram and gram, d. gram and milligram, and e. liter and milliliter.",
      "Solve problems involving conversion of units of length, mass, capacity, and time, including problems involving elapsed time in hours and minutes.",
      "Add and subtract similar fractions: a. two proper fractions, b. two mixed numbers, c. a mixed number and a proper fraction, d. a whole number and a proper fraction, and e. a whole number and a mixed number.",
      "Compare dissimilar fractions using the symbols =, >, and <.",
      "Order dissimilar fractions from smallest to largest, and vice versa.",
      "Generate equivalent fractions using models.",
      "Generate equivalent fractions using models.",
      "Find all the factors of a given number up to 100.",
      "Add and subtract dissimilar fractions using models.",
      "Add and subtract dissimilar fractions:  a. two proper fractions, b. two mixed numbers, c. a mixed number and a proper fraction,  d. a whole number and a proper fraction, and e. a whole number and a mixed number.",
      "Solve multi-step problems involving addition and/or subtraction of fractions.",
      "Identify symmetry with respect to a line.",
      "Interpret data presented in a tabular form, or in a single line graph.",
      "Interpret data presented in a tabular form, or in a single line graph.",
      "Solve problems using data for at most two variables in a tabular form, or in a single line graph.",
      "Describe the rule used to generate a given simple pattern.",
      "Complete a number sentence: a. to represent a property of operations (e.g., 4 + 3 = 3 + __) (commutative property of addition) b. to represent equivalent number facts (e.g., 4 + __ = 6 + 3)",
      "Read and write decimal numbers with decimal parts to hundredths.",
      "Determine: a. the place value to hundredths of a digit in a given decimal number, b. the value of a digit, and c. the digit of number, given its place value.",
      "Determine: a. the place value to hundredths of a digit in a given decimal number, b. the value of a digit, and c. the digit of number, given its place value.",
      "Convert decimal numbers to fractions, and fractions with denominators 10 or 100 to decimals.",
      "Compare and order decimal numbers with decimal parts to hundredths."
   ])
};

export const MTG4SCIENCE_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "part_1_matter",
         "label": "Matter",
         "start": 1,
         "count": 12,
         "mean": 7.05,
         "stdDev": 2.05,
         "ranges": [
            [0, 6.02, "Beginner"],
            [6.03, 9.1, "Basic"],
            [9.11, 12, "Competent"]
         ]
      },
      {
         "key": "part_2_living_things",
         "label": "Living Things",
         "start": 13,
         "count": 8,
         "mean": 4.9,
         "stdDev": 1.52,
         "ranges": [
            [0, 4.13, "Beginner"],
            [4.14, 6.42, "Basic"],
            [6.43, 8, "Competent"]
         ]
      },
      {
         "key": "part_3_force_motion_and_energy",
         "label": "Force, Motion, and Energy",
         "start": 21,
         "count": 13,
         "mean": 8.21,
         "stdDev": 1.73,
         "ranges": [
            [0, 7.34, "Beginner"],
            [7.35, 9.94, "Basic"],
            [9.95, 13, "Competent"]
         ]
      },
      {
         "key": "part_4_earth_and_space",
         "label": "Earth and Space",
         "start": 34,
         "count": 7,
         "mean": 3.79,
         "stdDev": 1.2,
         "ranges": [
            [0, 2.68, "Beginner"],
            [2.69, 4.49, "Basic"],
            [4.5, 7, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,23.56,"Beginner"],[23.57,30.63,"Basic"],[30.64,40,"Competent"]],
   totalSummary: {"count":40,"mean":25.95,"stdDev":4.71},
   sections: [
      {
         "label": "Part 1: Matter",
         "start": 1,
         "end": 12
      },
      {
         "label": "Part 2: Living Things",
         "start": 13,
         "end": 20
      },
      {
         "label": "Part 3: Force, Motion, and Energy",
         "start": 21,
         "end": 33
      },
      {
         "label": "Part 4: Earth and Space",
         "start": 34,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Use information from the home or the local community to identify a science invention and explain its impact on their everyday life.",
      "Use information from the home or the local community to identify a science invention and explain its impact on their everyday life.",
      "Describe the chemical properties of materials, such as they can be burnt, react with other materials, or are degradable or biodegradable.",
      "Describe the chemical properties of materials, such as they can be burnt, react with other materials, or are degradable or biodegradable.",
      "Describe changes in properties of materials when exposed to certain changes in temperature, such as changes when wood or coal are burned",
      "Describe changes in properties of materials when exposed to certain changes in temperature, such as changes when wood or coal are burned",
      "Demonstrate ways to minimize harmful changes in materials, such as restriction of burning of waste materials, and care in handling reactive materials.",
      "Demonstrate ways to minimize harmful changes in materials, such as restriction of burning of waste materials, and care in handling reactive materials.",
      "Identify issues and concerns in the local community and how they could be addressed by science, such as the treatment of waste",
      "Identify issues and concerns in the local community and how they could be addressed by science, such as the treatment of waste",
      "Apply science process skills and attitudes in conducting a guided survey about environmental issues and concerns including grouping and classifying, communicating, and open mindedness",
      "Apply science process skills and attitudes in conducting a guided survey about environmental issues and concerns including grouping and classifying, communicating, and open mindedness.",
      "Describe in simple terms how the following human body systems work: muscular, skeletal, digestive, circulatory, and respiratory.",
      "Describe in simple terms how the following human body systems work: muscular, skeletal, digestive, circulatory, and respiratory.",
      "Observe the root and shoot system in plants and describe why they are Important.",
      "Observe the root and shoot system in plants and describe why they are Important.",
      "Use a drawing or diagram to classify some Philippine animals and plants, based on their habitat: some live on land (terrestrial), live in water (aquatic) or fly in the air (aerial)",
      "Use a drawing or diagram to classify some Philippine animals and plants, based on their habitat: some live on land (terrestrial), live in water (aquatic) or fly in the air (aerial)",
      "Use flow charts to compare the different stages in the life cycle of animals, such as a butterfly, frog, chicken, and human",
      "Draw a simple food chain using living things from the Philippines and label them as herbivores, carnivores, and omnivores",
      "Construct and label simple graphs of different speeds including stationary and uniform speeds, both fast and slow",
      "Determine how forces can change the shape of objects such as when they are pushed, pulled, stretched, bent, twisted, or squeezed",
      "Determine how forces can change the shape of objects such as when they are pushed, pulled, stretched, bent, twisted, or squeezed",
      "Carry out guided investigations to identify the properties of magnets, including how they affect other magnets and objects made of different materials",
      "Carry out guided investigations to identify the properties of magnets, including how they affect other magnets and objects made of different materials",
      "Identify that energy is something that can cause change including light, sound, and heat energy",
      "Identify that energy is something that can cause change including light, sound, and heat energy",
      "Identify that energy is something that can cause change including light, sound, and heat energy",
      "Identify that energy is something that can cause change including light, sound, and heat energy",
      "Identify that energy is something that can cause change including light, sound, and heat energy",
      "Identify that energy is something that can cause change including light, sound, and heat energy",
      "Observe and identify sources and uses of light, sound, and heat energy at school, at home and in the local community",
      "Observe and identify sources and uses of light, sound, and heat energy at school, at home and in the local community",
      "Recognize that water is one of the basic needs of plants and animals",
      "Participate in a guided investigation to identify the effect of different types of soil on the growth of plants",
      "Identify some of the basic characteristics used to describe the weather, such as air temperature, air pressure, wind speed, wind direction, humidity, rain, and cloud cover.",
      "Use weather instruments to measure and record some of the characteristics of weather during a school day.",
      "Examine a local weather chart to make simple interpretations about the local weather and how it might change and describe and practice safety precautions to use during poor or extreme weather conditions.",
      "Describe some of the overall characteristics of the Sun, such as its composition, its size, and the main energy it radiates",
      "Describe the changes in the direction and length of shadows from a shadow stick and use the information to infer why the Sun changes position during a day;"
   ])
};

export const MTG5ENGLISH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_listening_and_reading",
         "label": "Listening and Reading",
         "start": 1,
         "count": 20,
         "mean": 6,
         "stdDev": 2.63,
         "ranges": [
            [0, 6.68, "Beginner"],
            [6.69, 10.63, "Basic"],
            [10.64, 20, "Competent"]
         ]
      },
      {
         "key": "b_speaking_and_writing",
         "label": "Speaking and Writing",
         "start": 21,
         "count": 10,
         "mean": 6.38,
         "stdDev": 1.75,
         "ranges": [
            [0, 5.5, "Beginner"],
            [5.51, 7.26, "Basic"],
            [7.27, 10, "Competent"]
         ]
      },
      {
         "key": "c_viewing_and_representing",
         "label": "Viewing and Representing",
         "start": 31,
         "count": 10,
         "mean": 5.57,
         "stdDev": 1.63,
         "ranges": [
            [0, 4.73, "Beginner"],
            [4.74, 6.41, "Basic"],
            [6.42, 10, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,18.05,"Beginner"],[18.06,23.73,"Basic"],[23.74,40,"Competent"]],
   totalSummary: {"count":40,"mean":19.95,"stdDev":3.73},
   sections: [
      {
         "label": "A. Listening and Reading",
         "start": 1,
         "end": 20
      },
      {
         "label": "B. Speaking and Writing",
         "start": 21,
         "end": 30
      },
      {
         "label": "C. Viewing and Representing",
         "start": 31,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Noting important elements (story grammar)",
      "Sequencing at least 7 events",
      "Identifying type of plot: flashback",
      "Analyzing figures of speech to get and clarify meaning: hyperbole",
      "Inferring: character's feelings and traits",
      "Making predictions: character's possible decision/action",
      "Drawing conclusions",
      "Identifying the main idea",
      "Summarizing story events",
      "Applying the important story elements to one’s schema: evaluating possibility of an event happening in real life",
      "Noting important information through outlining (topic, main idea, supporting details): deductive organization (inverted pyramid) (informational text)",
      "Noting important information through outlining (topic, main idea, supporting details): deductive organization (inverted pyramid) (informational text)",
      "Identifying text types: (a) explanation, (b) news report",
      "Identifying author’s purpose: (a) entertain, (b) inform, explain, describe",
      "Drawing conclusions",
      "Drawing conclusions",
      "Making generalizations",
      "Making generalizations",
      "Making a summary",
      "Distinguishing fact from opinion (statements of facts, opinions, and fact-based statements of opinion)",
      "Compose appropriate sentences for clarity and coherence: using kinds of verbs: transitive",
      "Compose appropriate sentences for clarity and coherence: using kinds of verbs: using past progressive tense",
      "Compose appropriate sentences for clarity and coherence: degrees of irregular adverbs",
      "Compose appropriate sentences for clarity and coherence: using complement pronouns",
      "Compose appropriate sentences for clarity and coherence: using complement adjectives",
      "Compose appropriate sentences for clarity and coherence: composing compound-complex sentences",
      "Produce text with introduction, body, and conclusion in conveying ideas: giving relevant information on a given topic",
      "Express ideas appropriately (age-appropriate, gender-responsive, culture sensitive) for one’s purpose, context, and target audience: using news report",
      "Use appropriate non-verbal cues for clarity of context, purpose, and meaning: using gestures",
      "Fill out forms accurately.",
      "Derive meaning based on the visual elements: interpreting tone and mood (colors, space, layout, directionality",
      "Derive meaning based on the visual elements: identifying the purpose of the visual text",
      "Derive meaning based on the visual elements: analyzing how visual elements contribute to the meaning of a text",
      "Derive meaning based on the visual elements: interpreting images/ideas that are explicitly used to influence viewers",
      "Derive meaning based on the visual elements: stereotypes on age and gender",
      "Evaluate cultural appropriateness of visual elements",
      "Create a visual text drawn from visual elements learned",
      "Identify multimedia elements: video (clip, film, tv ads, slide show, etc.).",
      "Derive meaning for multimedia elements learned: identifying the author’s purpose",
      "Create a multimedia text drawn from multimedia elements learned."
   ])
};

export const MTG5MATH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_number_and_algebra",
         "label": "Number and Algebra",
         "start": 1,
         "count": 20,
         "mean": 10.95,
         "stdDev": 2.96,
         "ranges": [
            [0, 9.46, "Beginner"],
            [9.47, 13.91, "Basic"],
            [13.92, 20, "Competent"]
         ]
      },
      {
         "key": "b_measurement_and_geometry",
         "label": "Measurement and Geometry",
         "start": 21,
         "count": 10,
         "mean": 5.9,
         "stdDev": 2.02,
         "ranges": [
            [0, 4.88, "Beginner"],
            [4.89, 7.92, "Basic"],
            [7.93, 10, "Competent"]
         ]
      },
      {
         "key": "c_data_and_probability",
         "label": "Data and Probability",
         "start": 31,
         "count": 10,
         "mean": 5,
         "stdDev": 1.7,
         "ranges": [
            [0, 4.14, "Beginner"],
            [4.15, 6.7, "Basic"],
            [6.71, 10, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,19.22,"Beginner"],[19.23,27.55,"Basic"],[27.56,40,"Competent"]],
   totalSummary: {"count":40,"mean":22,"stdDev":5.55},
   sections: [
      {
         "label": "A. Number and Algebra",
         "start": 1,
         "end": 20
      },
      {
         "label": "B. Measurement and Geometry",
         "start": 21,
         "end": 30
      },
      {
         "label": "C. Data and probability",
         "start": 31,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Perform three or more different operations by applying the GMDAS rules.",
      "Multiply a fraction by a fraction.",
      "Solve multi-step problems involving multiplication of fractions that may or may not also involve addition or subtraction ",
      "Divide a fraction by a fraction.",
      "Solve multi-step problems involving division of fractions that may or may not involve the other operations with fractions",
      "Convert terminating decimals to fractions, and vice versa.",
      "Compare and order decimal numbers with decimal parts to thousandths.",
      "Round decimal numbers to the nearest thousandths.",
      "Add and subtract decimal numbers with decimal parts of up to 3 decimal places.",
      "Solve multi-step problems involving addition and/or subtraction of decimals, including",
      "Problems involving money.",
      "Use divisibility rules to find common factors of numbers: divisibility rules for 2, 5, and 10.",
      "Use divisibility rules to find common factors of numbers: divisibility rules for 3, 6, and 9",
      "Multiply decimal numbers with decimal parts of up to 2 decimal places.",
      "Multiply decimal numbers with decimal parts of up to 2 decimal places.",
      "Solve multi-step problems involving multiplication of decimals that may or may not also involve addition or subtraction of decimals, including problems involving money",
      "Solve multi-step problems involving multiplication of decimals that may or may not also involve addition or subtraction of decimals, including problems involving money",
      "Divide: 1- to 2-digit whole numbers resulting in a terminating decimal quotient (e.g., 4 ÷ 5 = 0.8)",
      "Divide: decimal of up to 2 decimal places by a 1- to 2-digit whole number, resulting in a terminating decimal quotient of up to 3 decimal places.",
      "Solve multi-step problems involving division of decimals that may or may not also involve the other operations with decimals, including problems involving money.",
      "Solve problems involving 12- and 24-hour time.",
      "Compare the time in different world time zones to the time in the Philippines using a world time zone map.",
      "Solve problems on comparing the time in different world time zones to the time in the Philippines.",
      "Identify the height of a parallelogram, triangle, and trapezoid, in different orientations.",
      "Find the area of a parallelogram, triangle, and trapezoid, in sq. cm or sq. m, using formulas.",
      "Illustrate and find the surface area of solid figures.",
      "Solve problems involving the surface area of solid figures.",
      "Describe and distinguish cubes and rectangular prisms",
      "Estimate the volume of a cube and of a rectangular prism using non-standard units of measurement.",
      "Draw the image of an object after applying rotation about a point given an angle of rotation, clockwise or counterclockwise.",
      "Collects bivariate data from interview, questionnaire, and other appropriate sources.",
      "Identify the appropriate graph (bar graph or line graph) to represent a given set of data.",
      "Construct double bar graphs and double line graphs.",
      "Interpret data presented in a double bar graph or a double line graph.",
      "Interpret data presented in a double bar graph or a double line graph.",
      "Draw conclusions or make inferences based on data presented in a double bar graph or a double line graph.",
      "Solve problems using data presented in a double bar graph or a double line graph.",
      "Solve problems using data presented in a double bar graph or a double line graph.",
      "Describe probability as a measure of the chance of an event occurring",
      "Calculate the theoretical probability of a simple event by listing all possible outcomes."
   ])
};

export const MTG5SCIENCE_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_materials",
         "label": "Materials",
         "start": 1,
         "count": 10,
         "mean": 4.38,
         "stdDev": 2.01,
         "ranges": [
            [0, 3.37, "Beginner"],
            [3.38, 6.39, "Basic"],
            [6.4, 10, "Competent"]
         ]
      },
      {
         "key": "b_living_things",
         "label": "Living Things",
         "start": 11,
         "count": 10,
         "mean": 4.14,
         "stdDev": 1.42,
         "ranges": [
            [0, 3.42, "Beginner"],
            [3.43, 5.56, "Basic"],
            [5.57, 10, "Competent"]
         ]
      },
      {
         "key": "c_force_motion_and_energy",
         "label": "Force, Motion, and Energy",
         "start": 21,
         "count": 10,
         "mean": 4.33,
         "stdDev": 1.43,
         "ranges": [
            [0, 3.61, "Beginner"],
            [3.62, 5.76, "Basic"],
            [5.77, 10, "Competent"]
         ]
      },
      {
         "key": "d_earth_and_space",
         "label": "Earth and Space",
         "start": 31,
         "count": 10,
         "mean": 4.81,
         "stdDev": 1.75,
         "ranges": [
            [0, 3.93, "Beginner"],
            [3.94, 6.56, "Basic"],
            [6.57, 10, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,18.31,"Beginner"],[18.32,25.37,"Basic"],[25.38,40,"Competent"]],
   totalSummary: {"count":40,"mean":19.67,"stdDev":4.7},
   sections: [
      {
         "label": "A. Materials",
         "start": 1,
         "end": 10
      },
      {
         "label": "B. Living Things",
         "start": 11,
         "end": 20
      },
      {
         "label": "C. Force, Motion, and Energy",
         "start": 21,
         "end": 30
      },
      {
         "label": "D. Earth and Space",
         "start": 31,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Describe matter as anything that has mass and takes up space",
      "Identify that matter has (exists in) three states called solids, liquids, and gases",
      "Describe the properties of solids, liquids, and gases in terms of shape and volume: (a) solids: definite shape and volume, (b) liquids: no definite shape; definite volume, (c) gases: no definite shape or volume",
      "Identify objects at home and in the classroom as solid, liquid or gas",
      "Use measuring cylinders or beakers to measure volume using units, such as milliliters (mL), and liters (L)",
      "Describe how changes in temperature cause matter to change in state, such as solid to liquid to gas",
      "Describe the steps of a simple science investigation",
      "Identify and appropriately use units in simple science activities, such as milligrams (mg,) grams (g), kilograms (kg), and degrees centigrade (oC)",
      "Identify and appropriately use units in simple science activities, such as milligrams (mg,) grams (g), kilograms (kg), and degrees centigrade (oC)",
      "Plan simple scientific investigations in answering questions, such as “Do gases (like air) or liquids (like water) have mass?”, using appropriate simple science equipment, such as a balance, and a thermometer, with appropriate units",
      "Identify from pictures and labeled diagrams the parts of the digestive system as mouth, gullet, stomach, small intestine, and large intestine, and describe how they work",
      "Identify from pictures and labeled diagrams the parts of the digestive system as mouth, gullet, stomach, small intestine, and large intestine, and describe how they work",
      "Identify from pictures and diagrams the parts of the respiratory system as the nose, windpipe, and lungs, and describe how they work",
      "Identify from pictures and labeled diagrams the parts of the female reproductive system as ovaries, uterus, and vagina and those of the male reproductive system as the prostate, testis, and penis and describe how they work",
      "Use a table to show how living things can be classified into groups based on similar characteristics: (a) plants including flowering and non-flowering; (b) animals including mammals, reptiles, insects, birds, fish, amphibians, and reptiles; (c) microorganisms including fungi and bacteria",
      "Identify which groups of animals reproduce by giving birth to live young, such as mammals, and which reproduce by laying eggs, such as birds and reptiles",
      "Compare the life cycles of mammals from birth to adulthood, birds from egg to a mature organism, and plants from seed to a young plant, and then to a mature plant",
      "Describe the purpose of specialized structures in plants, such as rhizomes, tubers, thorns, bulbs, and aerial roots",
      "Explain how some plants have adapted to unfavorable conditions in the environment, such as lack of rain or floods",
      "Describe examples of how some animals have changed to better suit their environment, such as mimicry or camouflage",
      "Carry out simple investigations to demonstrate that contact forces cause objects to move in the same direction as the direction that the force is applied",
      "Plan and carry out a scientific investigation to determine the effect of different surfaces on the size of frictional forces",
      "Demonstrate how friction can produce heat and investigate ways of reducing and increasing friction.",
      "Identify gravity as a non-contact force that affects the behaviors of materials and objects on Earth in predictable ways",
      "Predict and explain whether heavier objects will fall faster than lighter objects due to the force of gravity",
      "Observe and describe the effects of gravity to the motion of an object",
      "Investigate the effects of static electricity using common materials, such as a comb, plastic and glass rods, and balloons",
      "Assemble and draw a simple circuit using batteries, wires, switch, and bulb and/or toy motor or buzzer",
      "Design and construct a simple electrical circuit to identify what materials will conduct electricity and use it to identify materials from the environment that will and will not conduct electricity",
      "Make a simple electromagnet and observe and record its properties",
      "Identify local examples of natural landforms and bodies of water such as mountains, valleys, rivers, and coastlines, and describe how they influence non-living and living components of the environment",
      "Observe or collect different types of rocks, describing their similarities and differences in terms of their features, such as texture, color, and grain crystal size",
      "Classify common rocks from provided samples using a simple rock classification system, such as a dichotomous key",
      "Explain how soil is formed from rocks and minerals",
      "Demonstrate how erosion transports Earth materials",
      "Explain the role of the water cycle in the environment",
      "Describe some effects of weather disturbances that occur in or near the Philippines",
      "Describe the weather conditions according to a Public Storm Warning Signal issued by the Philippine Atmospheric, Geophysical and Astronomical Services Administration (PAGASA)",
      "Describe typical weather conditions before, during and after a tropical cyclone",
      "Describe the general structure of the solar system, identifying the names of the major celestial objects, their main features, and general composition"
   ])
};

export const MTG6ENGLISH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_listening_and_reading",
         "label": "Listening and Reading: Literary Text",
         "start": 1,
         "count": 10,
         "mean": 5.79,
         "stdDev": 2.32,
         "ranges": [
            [0, 4.62, "Beginner"],
            [4.63, 7.89, "Basic"],
            [7.9, 10, "Competent"]
         ]
      },
      {
         "key": "b_listening_and_reading",
         "label": "Listening and Reading: Informational Text",
         "start": 11,
         "count": 13,
         "mean": 6.61,
         "stdDev": 3.88,
         "ranges": [
            [0, 4.7, "Beginner"],
            [4.71, 10.04, "Basic"],
            [10.05, 13, "Competent"]
         ]
      },
      {
         "key": "c_speaking_and_writing",
         "label": "Speaking and Writing",
         "start": 24,
         "count": 14,
         "mean": 6.42,
         "stdDev": 3.04,
         "ranges": [
            [0, 4.89, "Beginner"],
            [4.9, 9.19, "Basic"],
            [9.2, 14, "Competent"]
         ]
      }
      ,
      {
         "key": "d_viewing_and_representing",
         "label": "Viewing and Representing",
         "start": 38,
         "count": 8,
         "mean": 4.46,
         "stdDev": 2.04,
         "ranges": [
            [0, 3.6, "Beginner"],
            [3.61, 6.49, "Basic"],
            [6.5, 8, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,18.47,"Beginner"],[18.48,32.49,"Basic"],[32.5,45,"Competent"]],
   totalSummary: {"count":45,"mean":23.45,"stdDev":9.94},
   sections: [
      {
         "label": "Listening and Reading: Literary Text",
         "start": 1,
         "end": 10
      },
      {
         "label": "Listening and Reading: Informational Text",
         "start": 11,
         "end": 23
      },
      {
         "label": "Speaking and Writing",
         "start": 24,
         "end": 37
      },
      {
         "label": "Viewing and Representing",
         "start": 38,
         "end": 45
      }
   ],
   competencies: toCompetencies([
      "Noting important elements (story grammar)",
      "Sequencing at least 8 events",
      "Identifying type of plot: flashback",
      "Analyzing figures of speech to get and clarify meaning: irony",
      "Inferring: Author’s purpose, message, target audience",
      "Making predictions: Possible ending",
      "Drawing conclusions",
      "Identifying the main idea",
      "Summarizing story events",
      "Applying the important story elements to one’s schema: Learning vicariously from the text",
      "Noting important information through outlining (topic, main idea, supporting details): Inductive-deductive organization (diamond)",
      "Identifying text types: Persuasive",
      "Identifying author’s purpose: Entertain",
      "Identifying author’s purpose: Inform, explain, describe",
      "Identifying author’s purpose: Persuade",
      "Drawing conclusions",
      "Making generalizations",
      "Making a summary",
      "Distinguishing fact from opinion (statements of facts, opinions, and fact-based statements of opinion)",
      "Identifying propaganda technique used to persuade audience to further an idea or agenda: Fear",
      "Identifying propaganda technique used to persuade audience to further an idea or agenda: Half-truths or spin",
      "Identifying propaganda technique used to persuade audience to further an idea or agenda: Bad logic/unwarranted extrapolation",
      "Identifying propaganda technique used to persuade audience to further an idea or agenda: Card stacking",
      "Compose appropriate sentences for clarity and coherence",
      "Using kind of verbs: Intransitive",
      "Using tenses of verbs: Perfect – Present",
      "Using tenses of verbs: Perfect – Past",
      "Using tenses of verbs: Perfect – Future",
      "Using prepositional phrases as adverbs (adverbial phrase)",
      "Using complement: Noun",
      "Using complement: Pronoun",
      "Using complement: Adjective",
      "Composing compound-complex sentences",
      "Produce text with introduction, body, and conclusion in conveying ideas: Providing evidence to support information",
      "Express ideas appropriately (age-appropriate, gender-responsive, culture sensitive) for one’s purpose, context, and target audience: Using text types – Narrative",
      "Use appropriate non-verbal cues for clarity of context, purpose, and meaning: Using proxemics and blocking",
      "Create simple survey forms based on purpose: Online survey forms (digital)",
      "Derive meaning based on the visual elements: Identifying the purpose of the visual text",
      "Derive meaning based on the visual elements: Analyzing how visual elements contribute to the meaning of a text",
      "Evaluate cultural appropriateness of visual elements",
      "Identify multimedia elements: Video (clip, film, TV ads, slide show, etc.)",
      "Identify multimedia elements: Animation (two-dimensional, three-dimensional)",
      "Derive meaning from multimedia elements learned: Identifying the author’s purpose",
      "Determining ideas that are explicitly used to influence viewers: Author’s point of view/stand",
      "Determining ideas that are explicitly used to influence viewers: Propaganda technique used",
   ])
};

export const MTG6MATH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_number_and_algebra",
         "label": "Number and Algebra",
         "start": 1,
         "count": 29,
         "mean": 14.82,
         "stdDev": 8.96,
         "ranges": [
            [0, 12.57, "Beginner"],
            [12.58, 23.78, "Basic"],
            [23.79, 29, "Competent"]
         ]
      },
      {
         "key": "b_measurement_and_geometry",
         "label": "Measurement and Geometry",
         "start": 30,
         "count": 16,
         "mean": 6.455,
         "stdDev": 2.86,
         "ranges": [
            [0, 7.73, "Beginner"],
            [7.74, 11.31, "Basic"],
            [11.32, 16, "Competent"]
         ]
      },
      {
         "key": "c_data_and_probability",
         "label": "Data and Probability",
         "start": 46,
         "count": 5,
         "mean": 2.18,
         "stdDev": 1.01,
         "ranges": [
            [0, 1.92, "Beginner"],
            [1.93, 3.2, "Basic"],
            [3.21, 5, "Competent"]
         ]
      }
   ],
   totalRanges: [[0, 21.35, "Beginner"],[21.36, 41.83, "Basic"],[41.84, 50, "Competent"]],
   totalSummary: {"count":50, "mean":25.54, "stdDev":16.37},
   sections: [
      {
         "label": "A. Number and Algebra",
         "start": 1,
         "end": 29
      },
      {
         "label": "B. Measurement and Geometry",
         "start": 30,
         "end": 45
      },
      {
         "label": "C. Data and probability",
         "start": 46,
         "end": 50
      }
   ],
   competencies: toCompetencies([
      "Add and subtract decimals with decimal parts of up to 4 decimal places.",
      "Solve multi-step problems involving addition and/or subtraction of decimals, including problems involving money.",
      "Mentally multiply decimals of up to 2 decimal places by 0.1, 0.01, 0.001, 10, 100, and 1000.",
      "Solve multi-step problems involving multiplication of decimals that may or may not also involve addition or subtraction of decimals, including problems involving money.",
      "Divide 1- to 2-digit whole numbers resulting in a repeating (non-terminating) decimal quotient (e.g., 1/3 = 0.3333...).",
      "Divide a whole number by a decimal of 1 decimal place.",
      "Mentally divide decimals of up to 4 decimal places by 0.1, 0.01, and 0.001.",
      "Mentally divide decimals of up to 2 decimal places by 10, 100, and 1000.",
      "Solve problems involving division of decimals that may or may not involve the other operations with decimals and/or whole numbers.",
      "Obtain products that result from multiplying different combinations of fractions, whole numbers, and mixed numbers.",
      "Solve multi-step problems involving multiplication that may or may not involve addition or subtraction of different combinations of fractions, whole numbers, and mixed numbers.",
      "Divide different combinations of fractions, whole numbers, and mixed numbers.",
      "Solve multi-step problems involving division of different combinations of fractions, whole numbers, and mixed numbers.",
      "Describe the relationship between quantities using ratio for part-whole relationships.",
      "Describe the relationship between quantities using ratio for part-part relationships.",
      "Express one number as a fraction of another given their ratio, and vice versa.",
      "Identify and write equivalent ratios.",
      "Solve problems involving ratio.",
      "Illustrate ratio and proportion in given situations using tables and/or the double number line model.",
      "Find how many times one value is larger than another given their ratio, and vice versa.",
      "Solve problems involving ratio and proportion.",
      "Illustrate and explain the relationships between percentages, fractions, and decimals.",
      "Identify and explain the uses of percentages.",
      "Write numbers in exponential form (e.g., 2 × 2 × 2 = 2³) and vice versa (e.g., 2³ = 2 × 2 × 2).",
      "Give the value of numbers expressed in exponential form.",
      "Perform calculations involving numbers in exponential form by applying the GEMDAS rules.",
      "Determine the common factors and the greatest common factor (GCF) of two numbers using the following methods: listing, prime factorization, and continuous division.",
      "Find the common multiples and least common multiple (LCM) of two numbers using the following methods: listing, prime factorization, and continuous division.",
      "Solve problems involving GCF and LCM.",
      "Explore whether or not a shape tessellates.",
      "Determine appropriate units for measuring volume and capacity.",
      "Convert cubic centimeters (cm³) to liters (L), and vice versa.",
      "Find the volume of a cube and of a rectangular prism using standard units of measurement.",
      "Solve problems involving volumes of cubes and rectangular prisms.",
      "Solve problems involving capacity.",
      "Convert square centimeters (cm²) to square meters (m²), and vice versa.",
      "Find the area, in square meters (m²) or square centimeters (cm²), of composite figures composed of triangles, squares, and rectangles.",
      "Solve problems involving the perimeter and area of triangles, parallelograms, trapezoids, and composite figures composed of triangles, squares, and rectangles.",
      "Measure the circumference of circles using appropriate tools.",
      "Approximate the value of pi (π) as the ratio of the circumference to the diameter.",
      "Find the circumference of a circle using the formula (C = \pi d) or (C = 2\pi r).",
      "Explore inductively the area of a circle leading to the formula (A = \pi r^2).",
      "Find the area of a circle using the formula.",
      "Find the area of composite figures composed of any two or more of the following: triangle, square, rectangle, circle, and semicircle.",
      "Solve problems involving circumference and area of circles, and composite figures.",
      "Interpret data presented in a pie graph.",
      "Interpret data presented in a pie graph.",
      "Interpret data from digital media that are presented in tabular or graphical form.",
      "Draw conclusions or make inferences based on data presented in a pie graph.",
      "Solve problems using data presented in a pie graph."
   ])
};

export const MTG6SCIENCE_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_materials",
         "label": "Materials",
         "start": 1,
         "count": 10,
         "mean": 5.92,
         "stdDev": 2.33,
         "ranges": [
            [0, 4.18, "Beginner"],
            [4.19, 7.33, "Basic"],
            [7.34, 10, "Competent"]
         ]
      },
      {
         "key": "b_living_things",
         "label": "Living Things",
         "start": 11,
         "count": 10,
         "mean": 4.76,
         "stdDev": 2.67,
         "ranges": [
            [0, 3.41, "Beginner"],
            [3.42, 7.18, "Basic"],
            [7.19, 10, "Competent"]
         ]
      },
      {
         "key": "c_force_motion_and_energy",
         "label": "Force, Motion, and Energy",
         "start": 21,
         "count": 10,
         "mean": 3.88,
         "stdDev": 2.36,
         "ranges": [
            [0, 2.69, "Beginner"],
            [2.70, 6.02, "Basic"],
            [6.03, 10, "Competent"]
         ]
      },
      {
         "key": "d_earth_and_space",
         "label": "Earth and Space",
         "start": 31,
         "count": 10,
         "mean": 5.03,
         "stdDev": 2.73,
         "ranges": [
            [0, 3.65, "Beginner"],
            [3.66, 7.51, "Basic"],
            [7.52, 10, "Competent"]
         ]
      }
   ],
   totalRanges: [[0, 12.85, "Beginner"],[12.86, 31.2, "Basic"],[31.21, 40, "Competent"]],
   totalSummary: {"count":40, "mean":18.97, "stdDev":12.33},
   sections: [
      {
         "label": "A. Materials",
         "start": 1,
         "end": 10
      },
      {
         "label": "B. Living Things",
         "start": 11,
         "end": 20
      },
      {
         "label": "C. Force, Motion, and Energy",
         "start": 21,
         "end": 30
      },
      {
         "label": "D. Earth and Space",
         "start": 31,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Describe changes of state for solids, liquids, and gases as melting, evaporation, freezing, and condensation using diagrams and flowcharts.",
      "Explain the role of heat energy in change of state processes.",
      "Explain why physical changes are reversible, and chemical changes are irreversible.",
      "Describe useful everyday examples of uniform and non-uniform mixtures, such as solutions and suspensions.",
      "Describe air as a mixture of oxygen, carbon dioxide, nitrogen, and water vapor.",
      "Demonstrate various techniques in separating mixtures, such as decantation, winnowing, scooping, picking, evaporation, filtering, sieving, and using magnets.",
      "Explain the benefits of each mixture separation technique in preparing useful products.",
      "Apply the features of a fair test: (a) change one factor, (b) measure one factor, and (c) keep all other factors the same.",
      "Apply the features of a fair test: (a) change one factor, (b) measure one factor, and (c) keep all other factors the same.",
      "Recognize the features of a fair test and that scientific investigations also involve: (a) doing at least three trials, or use replication, and (b) observing, measuring, and recording accurately.",
      "Identify from pictures and diagrams the parts of the circulatory system as heart, blood, and blood vessels, and describe how they work.",
      "Describe the different ways that plants reproduce, such as pollination, seed production, and plant propagation.",
      "Plan a simple scientific investigation that includes the features of a fair test, replication, and accurate measurement to determine which type of plant propagation, such as cutting, budding, and grafting, is most effective.",
      "Describe the differences between animals with a backbone (vertebrates) and animals without backbones (invertebrates) by using common local examples of each group.",
      "Describe the roles of producers, consumers, scavengers, and decomposers in a food web.",
      "Describe the roles of producers, consumers, scavengers, and decomposers in a food web.",
      "Use information from secondary sources to describe that living things interact with each other in the natural environment, such as through competition or predation.",
      "Use information from secondary sources to describe that living things interact with each other in the natural environment, such as through competition or predation.",
      "Describe living things, such as animals and plants, as biotic factors and light, water, temperature, and other nonliving components as abiotic factors in an ecosystem.",
      "Explain how interaction between living things and interactions between living and non-living things may bring good or harm to the living things involved.",
      "Observe and describe examples and uses of simple machines found at home, at school, and in the community.",
      "Demonstrate through guided investigation the advantages and limitations of simple machines such as inclined planes, wedges, levers, and pulleys.",
      "Carry out fair tests to show how levers can be used to change the magnitude and direction of a force.",
      "Identify that waves carry energy from a source to a receiver.",
      "Carry out investigations with water waves in a ripple tank, a big tub of water or improvised ripple tank and observe and describe the features of the waves including their: (a) shape, such as crests and troughs; (b) size, such as width and height; (c) patterns of movement, such as how they bend, or reflect off walls.",
      "Research using secondary sources to identify how the properties of waves are described using scientific terms such as amplitude, frequency, wavelength, and velocity.",
      "Identify differences and similarities between longitudinal waves and transverse waves.",
      "Identify some examples of longitudinal waves and transverse waves.",
      "Demonstrate using simple models how longitudinal waves and transverse waves carry energy.",
      "Describe and explain how sound changes when the source or the receiver are moving.",
      "Explain what volcanoes are and how they are formed.",
      "Use local information or other reliable sources to identify where the nearest active and inactive volcanoes are located and assess the risk of impacts from eruptions to their local community.",
      "Discuss the patterns of volcanic eruptions in the Philippines over the last 100 years with family and community members to assess and describe how predictable patterns of eruptions are.",
      "Identify and describe some of the materials formed during volcanic eruptions in the Philippines.",
      "Interpret PHIVOLCS Volcano Monitoring (Alert Levels) to demonstrate what to do before, during, and after a volcanic eruption.",
      "Describe the different seasons in the Philippines and suggest activities that are appropriate for each season.",
      "Demonstrate the rotation of the Earth on its axis using a globe to explain day and night.",
      "Make a Sun-Earth-Moon system model to demonstrate and explain the observable effects of predictable patterns and events including: (a) changes in seasons; (b) changes observed in the patterns of visible stars over a year; and (c) solar and lunar eclipses.",
      "Explain why ancient human cultures relied on constellations to indicate directions and verify seasons.",
      "Gather information from local indigenous community members or from reliable secondary sources to investigate ways that indigenous people of the Philippines represented and communicated understandings of: (a) the predictability of solar and lunar eclipses; and (b) patterns/interpretations in the night sky and their use for tracking time."
   ])
};

export const MTG7ENGLISH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "part_1_evaluating_literary_text_poetry_prose_drama",
         "label": "Evaluating literary Text-Poetry, prose, drama",
         "start": 1,
         "count": 7,
         "mean": 3.93,
         "stdDev": 3.84,
         "ranges": [[0, 2, "Beginner"],[2.01, 5.85, "Basic"],[5.86, 7, "Competent"]]
      },
      {
         "key": "part_2_publishing_an_original_literary_text_that_reflects_culture",
         "label": "Publishing an original literary text that reflects culture",
         "start": 8,
         "count": 3,
         "mean": 1.5,
         "stdDev": 0.82,
         "ranges": [[0, 1.08, "Beginner"],[1.09, 2.32, "Basic"],[2.33, 3, "Competent"]]
      },
      {
         "key": "part_3_evaluating_informational_text_in_a_range_of_media_a_news_and_press_release",
         "label": "Evaluating Informational Text in a range of media",
         "start": 11,
         "count": 15,
         "mean": 6.21,
         "stdDev": 2.81,
         "ranges": [[0, 4.8, "Beginner"],[4.81, 9.02, "Basic"],[9.03, 15, "Competent"]]
      },
      {
         "key": "part_4_publishing_multimodal_informational_text_for_one_s_purpose_and_target_audience",
         "label": "Publishing Multimodal informational text for one’s purpose and target audience",
         "start": 26,
         "count": 5,
         "mean": 1.66,
         "stdDev": 2.81,
         "ranges": [[0, 0.25, "Beginner"],[0.26, 4.47, "Basic"],[4.48, 5, "Competent"]]
      },
      {
         "key": "part_5_evaluating_letters_for_clarity_of_purpose_and_meaning_letters_of_request",
         "label": "Evaluating letters for clarity of purpose and meaning-letters of request",
         "start": 31,
         "count": 5,
         "mean": 3.35,
         "stdDev": 1.48,
         "ranges": [[0, 2.6, "Beginner"],[2.61, 4.83, "Basic"],[4.84, 5, "Competent"]]
      },
      {
         "key": "part_6_sending_letters_to_communicate_with_and_respond_to_senders_letters_or_request",
         "label": "Sending letters to communicate with and respond to senders-letters or request",
         "start": 36,
         "count": 5,
         "mean": 2.02,
         "stdDev": 1.18,
         "ranges": [[0, 1.42, "Beginner"],[1.43, 3.2, "Basic"],[3.21, 5, "Competent"]]
      },
   ],
   totalRanges: [[0,20,"Beginner"],[20.01,25.52,"Basic"],[25.53,40,"Competent"]],
   totalSummary: {"count":40,"mean":23.56,"stdDev":5.88},
   sections: [
      {
         "label": "Part 1: Evaluating literary Text-Poetry, prose, drama",
         "start": 1,
         "end": 7
      },
      {
         "label": "Part 2: Publishing an original literary text that reflects culture",
         "start": 8,
         "end": 10
      },
      {
         "label": "Part 3: Evaluating Informational Text in a range of media: A. News and Press Release",
         "start": 11,
         "end": 18
      },
      {
         "label": "B. Expository Essay",
         "start": 19,
         "end": 25
      },
      {
         "label": "Part 4: Publishing Multimodal informational text for one’s purpose and target audience",
         "start": 26,
         "end": 30
      },
      {
         "label": "Part 5: Evaluating letters for clarity of purpose and meaning-letters of request",
         "start": 31,
         "end": 35
      },
      {
         "label": "Part 6: Sending letters to communicate with and respond to senders-letters or request",
         "start": 36,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Analyze literary text: structural, conflict",
      "Analyze literary text: biographical",
      "Analyze literary text: historical",
      "Analyze literary text: sociocultural",
      "Analyze the maxims, universal truths, and philosophies presented in the literary text as a means of valuing other people and their various circumstances in life",
      "Analyze the maxims, universal truths, and philosophies presented in the literary text as a means of valuing other people and their various circumstances in life",
      "Analyze the maxims, universal truths, and philosophies presented in the literary text as a means of valuing other people and their various circumstances in life",
      "Identify one’s meaning and purpose in selecting the type of literary text for composition",
      "Identify one’s meaning and purpose in selecting the type of literary text for composition",
      "Revise the literary texts for coherence and cohesion",
      "Examine text structures for clarity of meaning and purpose: Journalistic text",
      "Examine linguistic features as tools to achieve organizational efficiency in informational texts",
      "Extract significant information",
      "Analyze the real-world issues/occurrences presented in informational texts",
      "Distinguish facts from claims/opinions",
      "Analyze propaganda techniques used in informational texts for political correctness",
      "Draw inferences and conclusions to formulate sound judgment",
      "Analyze textual evidence to support an argument/general statement",
      "Examine text structures for clarity of meaning and purpose",
      "Examine linguistic features as tools to achieve organizational efficiency in informational texts",
      "Extract significant information",
      "Evaluate claims explicitly or implicitly made in a text",
      "Draw inferences and conclusions to formulate sound judgment:",
      "Analyze textual evidence to support an argument/general statement",
      "Synthesize significant information",
      "Identify the text type appropriate for one’s topic, purpose, and target audience",
      "Organize significant information using various technique",
      "Determine one’s thesis as the central idea of the paper",
      "Revise the text for coherence",
      "Revise the text for cohesion (diction, syntax, and style).",
      "Analyze distinguishing features of informal and formal correspondences to infer sender’s meaning and purpose across modalities: letter of request",
      "Analyze milieus influencing the structure and rhetoric of informal and formal correspondences across modalities:",
      "Examine the sender’s voice for clarity of purpose and meaning:",
      "Examine the sender’s voice for clarity of purpose and meaning:",
      "Examine how ethics is established in transmitting informal and formal correspondences across modalities",
      "Identify one’s purpose and meaning in writing letters",
      "Revise for coherence and cohesion",
      "Revise for coherence and cohesion",
      "Edit for consistency of diction, style, tone and register, point of view, and grammar",
      "Send correspondences to communicate with and respond to senders within the bounds of ethics"
   ])
};

export const MTG7MATH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "part_1_number_and_algebra",
         "label": "Number and Algebra",
         "start": 1,
         "count": 23,
         "mean": 15.23,
         "stdDev": 2.65,
         "ranges": [
            [0, 13.9, "Beginner"],
            [13.91, 17.88, "Basic"],
            [17.89, 23, "Competent"]
         ]
      },
      {
         "key": "part_2_measurement_and_geometry",
         "label": "Measurement and Geometry",
         "start": 24,
         "count": 10,
         "mean": 4.67,
         "stdDev": 1.62,
         "ranges": [
            [0, 3.85, "Beginner"],
            [3.86, 6.29, "Basic"],
            [6.3, 10, "Competent"]
         ]
      },
      {
         "key": "part_3_data_and_probability",
         "label": "Data and Probability",
         "start": 34,
         "count": 7,
         "mean": 4.26,
         "stdDev": 1.39,
         "ranges": [
            [0, 3.56, "Beginner"],
            [3.57, 5.65, "Basic"],
            [5.66, 7, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,16.58,"Beginner"],[16.59,22.51,"Basic"],[22.52,40,"Competent"]],
   totalSummary: {"count":40,"mean":18.56,"stdDev":3.95},
   sections: [
      {
         "label": "Part 1: Number and Algebra",
         "start": 1,
         "end": 23
      },
      {
         "label": "Part 2: Measurement and Geometry",
         "start": 24,
         "end": 33
      },
      {
         "label": "Part 3: Data and Probability",
         "start": 34,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Solve problems involving:  a. percentage increase, and b. percentage decrease,",
      "Solve money problems involving percentages (e. g., discount, commission, sales tax, simple interest).",
      "Solve problems involving rates (e.g., speed).",
      "Solve simple equations represented by bar models to find unknowns.",
      "Use positive and negative numbers to describe directions or opposites in real-life situations.",
      "Identify irrational numbers involving square roots and cube roots, and their locations on the number line.",
      "Determine the square roots of perfect squares and the cube roots of perfect cubes.",
      "Describe given rational numbers as fractions, decimals, or percentages.",
      "Describe given rational numbers as fractions, decimals, or percentages.",
      "Illustrate sets and their subsets, the union of sets, and the intersection of sets, through the use of Venn diagrams.",
      "Add and subtract integers; using concrete models (e.g., counters, integer chips), pictorial models (e.g., bar models, number lines), and with integers written as numerals.",
      "Multiply and divide integers.",
      "Multiply and divide integers.",
      "Perform operations on rational numbers.",
      "Perform operations on rational numbers.",
      "Convert units of measure within the International System of Units (SI) and across different systems of measure.",
      "Convert units of measure within the International System of Units (SI) and across different systems of measure.",
      "Perform operations on numbers expressed in scientific notation.",
      "Compare and order integers.",
      "Compare and order integers.",
      "Order rational numbers on a number line.",
      "Simplify numerical expressions involving integers using number properties and the order of operations (GEMDAS).",
      "Simplify numerical expressions involving integers using number properties and the order of operations (GEMDAS).",
      "Solve problems involving volumes of square or rectangular pyramids",
      "Solve problems involving the volumes of cylinders.",
      "Solve problems involving algebraic expressions and formulas",
      "Find the volume of a cylinder.",
      "Determine the measures of angles and the number of sides of polygons.",
      "Deduce the relationship between the exterior angle and the adjacent interior angle of a polygon.",
      "Estimate volumes of square and rectangular pyramids.",
      "Draw and describe regular and irregular polygons with 5, 6, 8, or 10 sides, based on measurements of sides and angles, using a ruler and protractor.",
      "Classify polygons according to the number of sides, whether they are regular or irregular, and whether they are convex or non-convex.",
      "Describe and explain the relationships between angle pairs based on their measures.",
      "Solve problems using the outcomes of experiments.",
      "Express outcomes in words and/or symbols, and represents outcomes in tables and/or graphs.",
      "Use appropriate graphs to represent organized data: pie graph, bar graph, line graph, and stem-and-leaf plot.",
      "Investigate different data collection and sampling techniques.",
      "Organize statistical data in a frequency distribution table.",
      "Interpret statistical graphs.",
      "Interpret statistical graphs."
   ])
};

export const MTG7SCIENCE_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "part_1_matter",
         "label": "Matter",
         "start": 1,
         "count": 11,
         "mean": 5.68,
         "stdDev": 1.79,
         "ranges": [
            [0, 4.78, "Beginner"],
            [4.79, 7.47, "Basic"],
            [7.48, 11, "Competent"]
         ]
      },
      {
         "key": "part_2_life_science",
         "label": "Life Science",
         "start": 12,
         "count": 11,
         "mean": 4.9,
         "stdDev": 1.52,
         "ranges": [
            [0, 4.13, "Beginner"],
            [4.14, 6.42, "Basic"],
            [6.43, 11, "Competent"]
         ]
      },
      {
         "key": "part_3_force_motion_and_energy",
         "label": "Force, Motion, and Energy",
         "start": 23,
         "count": 11,
         "mean": 4.4,
         "stdDev": 1.62,
         "ranges": [
            [0, 3.58, "Beginner"],
            [3.59, 6.02, "Basic"],
            [6.03, 11, "Competent"]
         ]
      },
      {
         "key": "part_4_earth_and_space",
         "label": "Earth and Space",
         "start": 34,
         "count": 7,
         "mean": 4.28,
         "stdDev": 1.25,
         "ranges": [
            [0, 3.65, "Beginner"],
            [3.66, 5.53, "Basic"],
            [5.54, 7, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,18.56,"Beginner"],[18.57,25.09,"Basic"],[25.1,40,"Competent"]],
   totalSummary: {"count":40,"mean":20.74,"stdDev":4.35},
   sections: [
      {
         "label": "Part 1: Matter",
         "start": 1,
         "end": 11
      },
      {
         "label": "Part 2: Life Science",
         "start": 12,
         "end": 22
      },
      {
         "label": "Part 3: Force, Motion, and Energy",
         "start": 23,
         "end": 33
      },
      {
         "label": "Part 4: Earth and Space",
         "start": 34,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Describe the Particle Model of Matter as “All matter is made up of tiny particles with each pure substance having its own kind of particles.",
      "Describe that particles are constantly in motion, have spaces between them, attract each other, and move faster as the temperature increases (or with the addition of heat)",
      "Use diagrams and illustrations to describe the arrangement, spacing, and relative motion of the particles in each of the three states (phases) of matter",
      "Explain the changes of state in terms of particle arrangement and energy changes: (a.) solid → liquid → vapor, and (b.) vapor → liquid → solid;",
      "Follow appropriate steps of a scientific investigation which includes: a. Aim or problem, b. Materials and equipment, c. Method or procedures, d. Results including data, and e. Conclusion.",
      "Make accurate measurements using standard units for physical quantities and organize the collected data when carrying out a scientific investigation",
      "Identify the role of the solute and solvent in a solution",
      "Express quantitatively the amount of solute present in a given volume of solution",
      "Demonstrate how different factors affect the solubility of a solute in a given solvent, such as heat",
      "Identify solutions, which can be found at home and in school and that react with litmus indicator, as acids, bases, and salts",
      "Demonstrate proper use and handling of science equipment.",
      "Identify the parts and functions, and demonstrate proper handling and storing of a compound microscope",
      "Identify the parts and functions, and demonstrate proper handling and storing of a compound microscope",
      "Use proper techniques in observing and identifying the parts of a cell with a microscope such as the cell membrane, nucleus, cytoplasm, mitochondria, chloroplasts, and ribosomes;",
      "Recognize that some organisms consist of a single cell (unicellular) like in bacteria and some consist of many cells (multicellular) like in a human;",
      "Differentiate plant and animal cells based on their organelles;",
      "Recognize that cells reproduce through two types of cell division, mitosis and meiosis, and describe mitosis as cell division for growth and repair;",
      "Explain that genetic information is passed onto offspring from both parents by the process of meiosis and fertilization",
      "Differentiate sexual from asexual reproduction in terms of: a) number of parents involved, and b) similarities of offspring to parents",
      "Use a labeled diagram to describe the connections between the levels of biological organization to one another from cells to the biosphere",
      "Describe the trophic levels of an organism as levels of energy in a food pyramid;",
      "Use examples of food pyramids to describe the transfer of energy between organisms from one trophic level to another.",
      "Identify that forces act between objects and can be measured.",
      "Identify and describe everyday situations that demonstrate: a. balanced forces such as a box resting on an inclined plane, a man standing still, or an object moving with constant velocity; b. unbalanced forces, such as freely falling fruit or an accelerating car",
      "Identify and describe everyday situations that demonstrate: a. balanced forces such as a box resting on an inclined plane, a man standing still, or an object moving with constant velocity; b. unbalanced forces, such as freely falling fruit or an accelerating car",
      "Identify that when forces are not balanced, they can cause changes in the object’s speed or direction of motion;",
      "Explain the difference between distance and displacement",
      "Distinguish between speed and velocity using the concept of vectors",
      "Describe uniform velocity and represent it using distance-time graphs",
      "Explain the difference between heat and temperature",
      "Identify advantageous and disadvantageous examples of conduction, convection, and radiation",
      "Explain in terms of the particle model the processes underlying convection and conduction of heat energy",
      "Explain in terms of the particle model the processes underlying convection and conduction of heat energy",
      "Classify geological faults according to the angle of the fault plane and direction of slip",
      "Describe how the effects of earthquakes on communities depend on their magnitude",
      "Explain how earthquakes result in tsunamis that devastate shoreline communities",
      "Describe procedures that the authorities have in place to alert communities of pending tsunamis and what procedures can be implemented should a tsunami impact a community",
      "Explain how energy from the Sun interacts with the atmosphere.",
      "Explain, using models, how the tilt of the Earth affects the changes in the length of daytime at different times of the year",
      "Explain how solar energy contributes to the occurrence of land and sea breezes, monsoons, and the Intertropical Convergence Zone (ITCZ)"
   ])
};

export const MTG8ENGLISH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_evaluating_literary_texts_afro_asian_literature_poetry_prose",
         "label": "Evaluating Literary Texts (Afro-Asian Literature - Poetry & Prose)",
         "start": 1,
         "count": 5,
         "mean": 3.75,
         "stdDev": 0.96,
         "ranges": [
            [0, 3.26, "Beginner"],
            [3.27, 4.23, "Basic"],
            [4.24, 5, "Competent"]
         ]
      },
      {
         "key": "b_evaluating_informational_text_in_a_range_of_media_spoken_written_visual_and_multimedia_for_clarity_of_meaning_purpose_form_persuasive_text",
         "label": "Evaluating informational text in a range of media (spoken, written, visual, and multimedia) for clarity of meaning, purpose, form (Persuasive Text)",
         "start": 6,
         "count": 9,
         "mean": 4.5,
         "stdDev": 0.96,
         "ranges": [
            [0, 4.01, "Beginner"],
            [4.02, 5.46, "Basic"],
            [5.47, 9, "Competent"]
         ]
      },
      {
         "key": "c_evaluating_informational_text_in_a_range_of_media_spoken_written_visual_and_multimedia_for_clarity_of_meaning_purpose_form_and_function_opinion_editorials",
         "label": "Evaluating informational text in a range of media (spoken, written, visual, and multimedia) for clarity of meaning, purpose, form, and function (Opinion Editorials)",
         "start": 15,
         "count": 10,
         "mean": 5.95,
         "stdDev": 4.96,
         "ranges": [
            [0, 5.26, "Beginner"],
            [5.27, 6.23, "Basic"],
            [6.24, 10, "Competent"]
         ]
      },
      {
         "key": "d_evaluating_informational_text_in_a_range_of_media_spoken_written_visual_and_multimedia_for_clarity_of_meaning_purpose_form_and_function_expository_essay",
         "label": "Evaluating informational text in a range of media (spoken, written, visual, and multimedia) for clarity of meaning, purpose, form, and function (Expository Essay)",
         "start": 25,
         "count": 12,
         "mean": 6.75,
         "stdDev": 0.98,
         "ranges": [
            [0, 6.25, "Beginner"],
            [6.26, 7.73, "Basic"],
            [7.74, 12, "Competent"]
         ]
      },
      {
         "key": "e_evaluating_letters_for_clarity_of_purpose_and_meaning_letter_of_inquiry",
         "label": "Evaluating letters for clarity of purpose and meaning (Letter of Inquiry)",
         "start": 37,
         "count": 4,
         "mean": 1.75,
         "stdDev": 0.96,
         "ranges": [
            [0, 1.26, "Beginner"],
            [1.27, 2.71, "Basic"],
            [2.72, 4, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,20.78,"Beginner"],[20.79,25.92,"Basic"],[25.93,40,"Competent"]],
   totalSummary: {"count":40,"mean":22.5,"stdDev":3.42},
   sections: [
      {
         "label": "A. Evaluating Literary Texts (Afro-Asian Literature - Poetry & Prose)",
         "start": 1,
         "end": 5
      },
      {
         "label": "B. Evaluating informational text in a range of media (spoken, written, visual, and multimedia) for clarity of meaning, purpose, form (Persuasive Text)",
         "start": 6,
         "end": 14
      },
      {
         "label": "C. Evaluating informational text in a range of media (spoken, written, visual, and multimedia) for clarity of meaning, purpose, form, and function (Opinion Editorials)",
         "start": 15,
         "end": 24
      },
      {
         "label": "D. Evaluating informational text in a range of media (spoken, written, visual, and multimedia) for clarity of meaning, purpose, form, and function (Expository Essay)",
         "start": 25,
         "end": 36
      },
      {
         "label": "E. Evaluating letters for clarity of purpose and meaning (Letter of Inquiry)",
         "start": 37,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Analyze Literary texts as expressions of individual or communal values within Structural context: Conflict",
      "Analyze Literary texts as expressions of individual or communal values within Biographical context",
      "Analyze Literary texts as expressions of individual or communal values within Biographical context",
      "Analyze Literary texts as expressions of individual or communal values within the Sociocultural context",
      "Identify one's meaning and purpose in selecting the type of literary text for composition: Poetry, prose, drama",
      "Examine text structures for clarity of meaning and purpose: Non-journalistic text: Persuasive Text",
      "Examine how visual elements are used to as tools to achieve the intended meaning of Informational texts: Vectors (for scientific, mathematical, or technical topics) and viewpoint",
      "Analyze the real-world issues/occurences presented in informational texts",
      "Analyze supporting evidence to validate assertions and counterclaims",
      "Draw inferences and conclusions to formulate sound judgment: Author's purpose and meaning",
      "Analyze textual evidence to support an argument/general statement",
      "Synthesize significant information: Persuasive text",
      "Organize significant information using various techniques",
      "Apply multimodal elements appropriate to the chosen text delivery/ies",
      "Examine text structures for clarity of meaning and purpose: Journalistic text: Sports articles as news, features, and editorials",
      "Examine text structures for clarity of meaning and purpose: Journalistic text: Science and Technology articles as news, features, and editorials",
      "Examine how visual elements are used to as tools to achieve the intended meaning of Informational texts: Technical Editing",
      "Analyze the real-world issues/occurences presented in informational texts",
      "Analyze how non-linear texts represent and/or summarize the contents of informational texts: Photographs",
      "Determine the veracity of the information presented: Credibility of the author",
      "Determine the veracity of the information presented: Credibility of the author",
      "Analyze textual evidence to support an argument/general statement: Quoting",
      "Assess the quality of journalistic article based on standard development principles: Simplicity and brevity",
      "Organize significant information using various techniques",
      "Examine text structures for clarity of meaning and purpose: Academic text: Expository Essay",
      "Analyze the use of discipline-specific words, voice, technical terms in research, and conceptual, operational, and expanded definition of words",
      "Analyze supporting evidence to validate assertions and counterclaims: Statistical inferences",
      "Analyze supporting evidence to validate assertions and counterclaims: Informed opinion",
      "Analyze supporting evidence to validate assertions and counterclaims: Personal testimony",
      "Evaluate claims explicitly or implicitly made in a text: Claim of fact",
      "Draw inferences and conclusions to formulate sound judgment: Target audience: Hypothetical vs. real",
      "Analyze textual evidence to support an argument/general statement: Paraphrasing",
      "Synthesize significant information: Expository Essay",
      "Identify text type appropriate for one's topic, purpose, and target audience: Expository Essay",
      "Determine one's thesis as the central idea of the paper",
      "Apply multimodal elements appropriate to the chosen text delivery/ies",
      "Analyze distinguishing features of informal and formal correspondences to infer sender's meaning and purpose across modalities: Letter of inquiry",
      "Analyze milieus influencing the structure and rhetoric of informal and formal correspondences across modalities: Parts and formats",
      "Analyze milieus influencing the structure and rhetoric of informal and formal correspondences across modalities: Politeness strategies (etiquette)",
      "Identify one’s purpose and meaning in writing letters: Letter of inquiry"
   ])
};

export const MTG8MATH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_measurement_and_geometry",
         "label": "Measurement and Geometry",
         "start": 1,
         "count": 8,
         "mean": 4,
         "stdDev": 0.82,
         "ranges": [
            [0, 3.58, "Beginner"],
            [3.59, 4.82, "Basic"],
            [4.83, 10, "Competent"]
         ]
      },
      {
         "key": "b_number_and_algebra",
         "label": "Number and Algebra",
         "start": 9,
         "count": 21,
         "mean": 10.25,
         "stdDev": 1.89,
         "ranges": [
            [0, 9.3, "Beginner"],
            [9.31, 12.14, "Basic"],
            [12.15, 20, "Competent"]
         ]
      },
      {
         "key": "c_data_and_probability",
         "label": "Data and Probability",
         "start": 30,
         "count": 11,
         "mean": 5.25,
         "stdDev": 1.5,
         "ranges": [
            [0, 4.49, "Beginner"],
            [4.5, 6.75, "Basic"],
            [6.76, 10, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,16.95,"Beginner"],[16.96,27.58,"Basic"],[27.59,40,"Competent"]],
   totalSummary: {"count":40,"mean":20.5,"stdDev":2.08},
   sections: [
      {
         "label": "A. Measurement and Geometry",
         "start": 1,
         "end": 8
      },
      {
         "label": "B. Number and Algebra",
         "start": 9,
         "end": 29
      },
      {
         "label": "C. Data and probability",
         "start": 30,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Find the volume of pyramids other than square and rectangular pyramids",
      "Find the volumes of cones and spheres",
      "Plot points on the Cartesian coordinate plane and determine the coordinates of a point on the plane",
      "Solve problems involving distance between two points and midpoint of a line segment on the Cartesian coordinate plane",
      "Solve problems involving volume of pyramids",
      "Solve problems involving the volume of cones and spheres",
      "Apply the Pythagorean Theorem in finding the missing side of a right triangle, and its converse in classifying triangles",
      "Apply the triangle inequality theorems to establish results of angles and sides in triangles",
      "Model real-life situations using algebraic expressions",
      "Add and subtract simple monomials",
      "Solve linear inequalities in one variable",
      "Graph on a number line the solution of linear inequalities in one variable",
      "Solve problems involving linear inequalities in one variable",
      "Describe a linear equation in two variables and express its solution using ordered pairs",
      "Define and determine the slope and intercepts of a line",
      "Find the equation of a line given: c. the slope and y-intercept; and d. The x-and y-intercepts",
      "Find the equation of a line given: d. The x-and y-intercepts",
      "Sketch the graph (straight line) of a linear equation given: b. the x- and y-intercepts",
      "Sketch the graph (straight line) of a linear equation given: c. The slope and a point on the line",
      "Solve a system of linear equations (with integer solutions) by graphing",
      "Solve algebraically a system of linear equations in two variables",
      "Recognize and solve problems involving linear inequalities in two variables",
      "Solve financial problems involving: a. Earning money",
      "Solve financial problems involving: b. Profit and loss",
      "Solve financial problems involving: c. Buying amounts of products that represent the best value ('best buys')",
      "Solve linear equations in one variable",
      "Solve problems (e.g., number problems, geometry problems, and money problems) involving linear equations in one variable",
      "Find the equation of a line given: a. two points",
      "Find the equation of a line given: b. The slope and a point",
      "Determine measures of central tendency of ungrouped data",
      "Draw conclusions from statistical data using the measures of central tendency",
      "Calculate the measures of variability (range, mean deviation, and standard deviation) for ungrouped data",
      "Investigate, interpret, and analyze graphs from primary data (e.g., examination scores)",
      "Investigate, interpret, and analyze graphs from secondary data",
      "Differentiate theoretical from experimental probability by conducting an experiment or an investigation",
      "Use the Fundamental Counting Principle to determine the number of possible outcomes of an experiment",
      "Calculate the theoretical probability of a single event by listing all possible outcomes",
      "Describe probability as a measure of the chance of an event occurring",
      "Calculate the probability of simple combined events by listing, or by possibility diagrams or tree diagrams",
      "Solve problems involving experimental probability and/or theoretical probability using the Fundamental Counting Principle"
   ])
};

export const MTG8SCIENCE_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_science_of_materials",
         "label": "Science of Materials",
         "start": 1,
         "count": 8,
         "mean": 4.25,
         "stdDev": 0.5,
         "ranges": [
            [0, 3.99, "Beginner"],
            [4, 4.75, "Basic"],
            [6.4, 8, "Competent"]
         ]
      },
      {
         "key": "b_life_sciences",
         "label": "Life Sciences",
         "start": 9,
         "count": 9,
         "mean": 4.25,
         "stdDev": 0.5,
         "ranges": [
            [0, 3.42, "Beginner"],
            [3.43, 5.56, "Basic"],
            [5.57, 9, "Competent"]
         ]
      },
      {
         "key": "c_force_motion_and_energy",
         "label": "Force, Motion, and Energy",
         "start": 18,
         "count": 10,
         "mean": 4.25,
         "stdDev": 1.25,
         "ranges": [
            [0, 3.62, "Beginner"],
            [3.63, 5.5, "Basic"],
            [5.51, 10, "Competent"]
         ]
      },
      {
         "key": "d_earth_and_space",
         "label": "Earth and Space",
         "start": 28,
         "count": 13,
         "mean": 6.5,
         "stdDev": 2.38,
         "ranges": [
            [0, 5.3, "Beginner"],
            [5.31, 8.88, "Basic"],
            [8.89, 13, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,21.3,"Beginner"],[21.31,24.14,"Basic"],[24.15,40,"Competent"]],
   totalSummary: {"count":40,"mean":22.25,"stdDev":1.89},
   sections: [
      {
         "label": "A. Science of Materials",
         "start": 1,
         "end": 8
      },
      {
         "label": "B. Life Sciences",
         "start": 9,
         "end": 17
      },
      {
         "label": "C. Force, Motion, and Energy",
         "start": 18,
         "end": 27
      },
      {
         "label": "D. Earth and Space",
         "start": 28,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Develop a timeline for the historical background of the development of the current Atomic Model that identifies tiny particles as atoms",
      "Use the structure of an atom to illustrate the nucleus and electron shells",
      "Differentiate the subatomic particles protons, neutrons, and electrons in terms of their symbol, mass, charge, and location within an atom",
      "Describe the properties of pure substances as: a. having fixed chemical composition, examples of which are elements and compounds",
      "Describe the properties of pure substances as: b. that all the atoms of an element have unique number of protons",
      "Discuss the significant contributions of early scientists in the development of the periodic table",
      "Identify the names and symbols of the first 20 or several common elements of the periodic table",
      "Explain that the arrangement of elements in the periodic table as 7 periods and 18 groups is based on their atomic structure and chemical properties, such as reactivity",
      "Using a labeled diagram, trace how food travels through the digestive tract and explain how different digestive processes work, including mechanical processing, secretion, digestion, absorption, and elimination",
      "Use models, flow charts, diagrams, and simulations to explain how body systems work together, such as digestion and excretion",
      "Describe how plants plant organs (leaf, stem, roots) work together as the transport system",
      "Represent patterns of inheritance of a simple dominant/recessive characteristic through generations of a family",
      "Describe the importance of the six-kingdom system and the three-domain system of classification of living things",
      "Explain why humans are classified under Class Mammalia and the Order Primates",
      "Using flow charts and labeled diagrams explain the role of plants and animals in the cycles of nature, such as the carbon, oxygen, and water cycles",
      "Describe the process of photosynthesis and respiration, and identify its raw materials needed and products",
      "Plan a scientific investigation to verify the raw materials needed for photosynthesis",
      "Identify that forces cause objects to accelerate, and that acceleration of an object is its rate of change of velocity",
      "Observe and describe examples of accelerating objects at school and in the local community, including objects that show uniform circular motion",
      "Describe kinetic energy as the movement of objects or particles, and potential energy as energy stored due to the position of objects or particles",
      "Identify examples of everyday situations that demonstrate: a. kinetic energy being transformed to potential energy",
      "Identify examples of everyday situations that demonstrate: a. kinetic energy being transformed to potential energy",
      "Recognize that work is done when a force causes the displacement of an object",
      "Explain that the mechanical energy of an object is the sum of the kinetic energy and the potential energy available to do work",
      "Describe conservation of energy in everyday situations involving gravity, such as when objects fall",
      "Gather information from secondary sources to explain how potential energy stored in lakes and dams in the Philippines is used to produce kinetic energy to generate electricity for use in homes, communities, and industry",
      "Carry out guided investigations to describe and illustrate the reflection of light using plane and curved mirrors and the refraction of light using transparent blocks, lenses, and prisms with examples from everyday applications",
      "Identify what proportion of the Earth's surface is covered with water as opposed to land",
      "Gather information from secondary sources to name and describe the upper crustal layers of the solid earth",
      "Describe the different types of volcanoes found around the world according to their: a. activity",
      "Describe the different types of volcanoes found around the world according to their: b. type of eruption",
      "Describe the different types of volcanoes found around the world according to their: c. location in the crust.",
      "Relate the shape of a volcano's cone to its composition",
      "Relate the location and distribution of active volcanoes, earthquake epicenters, and major mountain belts to the distribution of oceanic crust and continental crust",
      "Identify how oceanic crust and continental crust is associated with the Earth's lithosphere plates",
      "Gather information from secondary sources to explain: a. how typhoons develop; and b. why the Philippines is prone to typhoons",
      "Use a map and a record of tracking data to trace the path of typhoons that enter the Philippine Area of Responsibility (PAR)",
      "Discuss how bodies of water and landforms affect typhoons",
      "Relate the relative movements of the Earth, Moon, and Sun with the occurrence of tides",
      "Draw on information from secondary sources to identify situations where tidal difference could be exploited to generate renewable energy"
   ])
};

export const MTG9ENGLISH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_evaluating_literary_texts_anglo_american_poetry_prose_drama",
         "label": "Evaluating Literary Texts (Anglo-American Poetry, Prose, and Drama)",
         "start": 1,
         "count": 7,
         "mean": 2.857142857,
         "stdDev": 1.27615494,
         "ranges": [
            [0, 2.53, "Beginner"],
            [2.54, 5.13, "Basic"],
            [5.14, 7, "Competent"]
         ]
      },
      {
         "key": "b_evaluating_informational_text_in_a_range_of_media_argumentative_text",
         "label": "Evaluating informational text in a range of media (Argumentative Text)",
         "start": 8,
         "count": 12,
         "mean": 7.142857143,
         "stdDev": 2.62333647,
         "ranges": [
            [0, 6.47, "Beginner"],
            [6.48, 10.77, "Basic"],
            [10.78, 12, "Competent"]
         ]
      },
      {
         "key": "c_evaluating_informational_text_in_a_range_of_media_for_clarity_of_meaning_purpose_form_and_function",
         "label": "Evaluating informational text in a range of media for clarity of meaning, purpose, form, and function",
         "start": 20,
         "count": 10,
         "mean": 5.571428571,
         "stdDev": 2.853570106,
         "ranges": [
            [0, 4.85, "Beginner"],
            [4.86, 8.40, "Basic"],
            [8.41, 10, "Competent"]
         ]
      },
      {
         "key": "d_evaluating_letter_for_clarity_of_meaning_purpose",
         "label": "Evaluating letter for clarity of purpose and meaning",
         "start": 30,
         "count": 2,
         "mean": 1.523809524,
         "stdDev": 0.3,
         "ranges": [
            [0, 1.44, "Beginner"],
            [1.45, 1.62, "Basic"],
            [1.63, 2, "Competent"]
         ]
      },
      {
         "key": "e_evaluating_informational_text_literature_review",
         "label": "Evaluating informational text – Literature Review",
         "start": 32,
         "count": 9,
         "mean": 5.476190476,
         "stdDev": 2.064438031,
         "ranges": [
            [0, 4.95, "Beginner"],
            [4.96, 7.54, "Basic"],
            [7.55, 9, "Competent"]
         ]
      }
   ],
   totalRanges: [[0, 22.89,"Beginner"],[22.9, 32.97,"Basic"],[32.98, 40,"Competent"]],
   totalSummary: {"count":40, "mean":24.714285714, "stdDev":7.253138293},
   sections: [
      {
         "label": "A. Evaluating Literary Texts (Anglo-American Poetry, Prose, and Drama)",
         "start": 1,
         "end": 7
      },
      {
         "label": "B. Evaluating informational text in a range of media (Argumentative Text)",
         "start": 8,
         "end": 19
      },
      {
         "label": "C. Evaluating informational text in a range of media for clarity of meaning, purpose, form, and function",
         "start": 20,
         "end": 29
      },
      {
         "label": "D. Evaluating letter for clarity of purpose and meaning",
         "start": 30,
         "end": 31
      },
      {
         "label": "E. Evaluating informational text – Literature Review",
         "start": 32,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Analyze literary texts as expressions of individual or communal values within Structural Context: Conflict",
      "Analyze literary texts as expressions of individual or communal values within Structural Context: Plot",
      "Analyze literary texts as expressions of individual or communal values within Structural Context: Figures of Speech and Sound Devices",
      "Analyze literary texts as expressions of individual or communal values within Sociocultural Context",
      "Identify one's meaning and purpose in selecting the type of literary text for composition: Poetry, Prose, Drama",
      "Analyze literary texts as expressions of individual or communal values within Linguistic Context: Collocation",
      "Analyze maxims, universal truths, and philosophies presented in literary texts as a means of valuing other people and their various circumstances in life",
      "Examine text structures for clarity of meaning and purpose: Non-journalistic Text – Argumentative Text",
      "Examine linguistic features as tools to achieve organizational efficiency in informational texts: Sentence Structure and Function",
      "Examine how visual elements are used as tools to achieve the intended meaning of informational texts: Technical Editing",
      "Examine how visual elements are used as tools to achieve the intended meaning of informational texts: Animations",
      "Analyze the real-world issues/occurrences presented in informational texts",
      "Analyze supporting evidence to validate assertions and counterclaims: Personal Testimony",
      "Distinguish facts from claims/opinions: Self-evidence",
      "Evaluate claims explicitly or implicitly made in a text: Claim of Fact",
      "Analyze propaganda techniques used in informational texts for political correctness: Name Calling vs. Card Stacking",
      "Analyze textual evidence to support an argument/general statement: Summarizing",
      "Synthesize significant information: Argumentative Text",
      "Determine one's thesis as the central idea of the paper",
      "Examine how visual elements are used as tools to achieve the intended meaning of informational texts: Technical Editing",
      "Analyze the real-world issues/occurrences presented in informational texts",
      "Analyze supporting evidence to validate assertions and counterclaims: Factual Knowledge",
      "Analyze persuasive techniques to support an argument: Ethos",
      "Analyze persuasive techniques to support an argument: Logos",
      "Analyze persuasive techniques to support an argument: Pathos",
      "Draw inferences and conclusions to formulate sound judgment: Author's Purpose and Meaning",
      "Analyze textual evidence to support an argument/general statement: Paraphrasing",
      "Identify text type appropriate for one's topic, purpose, and target audience: Argumentative Text",
      "Organize significant information using various techniques",
      "Analyze distinguishing features of informal and formal correspondences to infer sender's meaning and purpose across modalities: Letter of Complaint",
      "Identify one's purpose and meaning in writing letters: Letter of Complaint",
      "Examine text structures for clarity of meaning and purpose: Academic Text – Literature Review",
      "Extract significant information: Literature Review",
      "Analyze supporting evidence to validate assertions and counterclaims: Factual Knowledge",
      "Draw inferences and conclusions to formulate sound judgment: Target Audience – Experts vs. Laypeople",
      "Analyze textual evidence to support an argument/general statement: Paraphrasing",
      "Synthesize significant information: Literature Review",
      "Organize significant information using various techniques",
      "Determine one's thesis as the central idea of the paper",
      "Apply multimodal elements appropriate to the chosen text delivery/ies"
   ])
};

export const MTG9MATH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_measurement_and_geometry",
         "label": "Measurement and Geometry",
         "start": 1,
         "count": 24,
         "mean": 7.428571429,
         "stdDev": 2.180170834,
         "ranges": [
            [0, 7.24, "Beginner"],
            [7.25, 18.61, "Basic"],
            [18.62, 24, "Competent"]
         ]
      },
      {
         "key": "b_number_and_algebra",
         "label": "Number and Algebra",
         "start": 25,
         "count": 13,
         "mean": 6.047619048,
         "stdDev": 1.774152488,
         "ranges": [
            [0, 5.59, "Beginner"],
            [5.6, 8.82, "Basic"],
            [8.83, 13, "Competent"]
         ]
      },
      {
         "key": "c_data_and_probability",
         "label": "Data and Probability",
         "start": 38,
         "count": 3,
         "mean": 1.395238095,
         "stdDev": 0.794324165,
         "ranges": [
            [0, 1.19, "Beginner"],
            [1.2, 1.69, "Basic"],
            [1.7, 3, "Competent"]
         ]
      }
   ],
   totalRanges: [[0, 16.01, "Beginner"], [16.02, 20.02, "Basic"], [20.03, 40,"Competent"]],
   totalSummary: {"count":40, "mean":16.619047619, "stdDev":2.4},
   sections: [
      {
         "label": "A. Measurement and Geometry",
         "start": 1,
         "end": 24
      },
      {
         "label": "B. Number and Algebra",
         "start": 25,
         "end": 37
      },
      {
         "label": "C. Data and probability",
         "start": 38,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Illustrate and describe point, line, ray, line segment, angle, and plane using models and geometric notations",
      "Construct perpendicular and parallel lines",
      "Identify the relationships between angles formed by parallel lines cut by a transversal",
      "Determine angle measures involving angle pairs, parallel and perpendicular lines, and parallel lines cut by a transversal",
      "Illustrate similarity of polygons",
      "Illustrate and apply triangle similarity theorems in different situations",
      "Solve real-life problems involving right triangles through the application of the trigonometric ratios",
      "Solve problems involving measures of sides and angles of special triangles (30-60-90, 45-45-90)",
      "Solve problems involving the perpendicular bisector theorem, isosceles triangle theorem, theorems on equilateral triangles, and the midline theorem",
      "Explain theorems on triangle inequalities and apply these theorems in comparing measures in a triangle",
      "Determine the values of the sine, cosine, and tangent trigonometric ratios corresponding to the angles of the special triangles",
      "Find the values of the sine, cosine, and tangent ratios of any acute angle",
      "Use the trigonometric ratios in solving right triangles",
      "Illustrate angles of elevation and angles of depression",
      "Determine conditions that guarantee parallelism and perpendicularity of lines",
      "Solve problems involving parallelograms, rectangles, squares, or rhombuses by applying their different properties",
      "Prove properties of parallelograms by applying the relevant theorems",
      "Solve problems on trapezoids and kites by applying their properties",
      "Use the triangle congruence postulates and theorems to illustrate the congruence of triangles, including CPCTC (definition of congruent triangles)",
      "Solve problems involving right triangle congruence theorems, isosceles triangle theorem, perpendicular bisector theorem, and midline theorem",
      "Construct and justify the construction of segments, angles, and triangles, including, but not limited to, the triangle's secondary parts and centers, using the triangle congruence postulates and theorems",
      "Construct congruence proofs involving triangles or corresponding parts of triangles using a two-column proof",
      "Distinguish inductive and deductive reasoning for establishing proofs",
      "State postulates and theorems about defined and undefined terms in geometry, and formulate proofs involving them",
      "Represent real-life situations that can be modeled using quadratic relationships",
      "Graph equations in two variables to represent quadratic relationships",
      "Interpret features of a parabola such as a vertex, the axis of symmetry, x-intercepts, opening direction, minimum or maximum value, zeros, and increasing and decreasing intervals",
      "Transform quadratic functions into vertex form and vice versa",
      "Sketch the graph of quadratic functions expressed in equation form",
      "Analyze the effect of changing the values of the parameters on the behavior of its graph and on the properties of the quadratic function",
      "Find the zeroes of quadratic functions in factored and standard form, graphically and algebraically",
      "Solve quadratic equations by extracting square roots",
      "Solve quadratic equations by factoring",
      "Solve quadratic equations using the quadratic formula",
      "Solve problems involving quadratic functions and equations",
      "Illustrate real-life situations that involve direct variation and inverse variation",
      "Solve problems involving variation",
      "Interpret and analyze data from digital media that are in tabular or graphical form to assess whether the data may be misleading",
      "Determine the probabilities of simple and compound events",
      "Solve problems involving probabilities of simple and compound events"
   ])
};

export const MTG9SCIENCE_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_science_of_materials",
         "label": "Science of Materials",
         "start": 1,
         "count": 6,
         "mean": 2.952380952,
         "stdDev": 1.203170419,
         "ranges": [
            [0, 2.64, "Beginner"],
            [2.65, 4.16, "Basic"],
            [4.17, 6, "Competent"]
         ]
      },
      {
         "key": "b_life_sciences",
         "label": "Life Sciences",
         "start": 7,
         "count": 8,
         "mean": 3.714285714,
         "stdDev": 1.90112743,
         "ranges": [
            [0, 3.23, "Beginner"],
            [3.24, 6.62, "Basic"],
            [6.63, 8, "Competent"]
         ]
      },
      {
         "key": "c_force_motion_and_energy",
         "label": "Force, Motion, and Energy",
         "start": 15,
         "count": 12,
         "mean": 5.19047619,
         "stdDev": 1.778174559,
         "ranges": [
            [0, 4.74, "Beginner"],
            [4.75, 7.97, "Basic"],
            [7.98, 12, "Competent"]
         ]
      },
      {
         "key": "d_earth_and_space",
         "label": "Earth and Space",
         "start": 27,
         "count": 14,
         "mean": 6.80952381,
         "stdDev": 1.289148074,
         "ranges": [
            [0, 6.48, "Beginner"],
            [6.49, 9.10, "Basic"],
            [9.11, 14, "Competent"]
         ]
      }
   ],
   totalRanges: [[0,21.3,"Beginner"],[21.31,24.14,"Basic"],[24.15,40,"Competent"]],
   totalSummary: {"count":40, "mean":18.666666667, "stdDev":3.076794869},
   sections: [
      {
         "label": "A. Science of Materials",
         "start": 1,
         "end": 6
      },
      {
         "label": "B. Life Sciences",
         "start": 7,
         "end": 14
      },
      {
         "label": "C. Force, Motion, and Energy",
         "start": 15,
         "end": 26
      },
      {
         "label": "D. Earth and Space",
         "start": 27,
         "end": 40
      }
   ],
   competencies: toCompetencies([
      "Explain that the formation of new bonds or the breaking of existing bonds constitutes chemical change and the formation of a new substance.",
      "Describe a valence electron as an electron in the outer shell of an atom that can take part in the formation of bonds.",
      "Explain the formation of covalent bonds using a molecule of water and a molecule of carbon dioxide.",
      "Show by using models that ionic compounds form crystalline structures whereas covalent compounds form individual molecules.",
      "Explain the properties of metals in terms of their structure and metallic bonding (sea of electrons model).",
      "Investigate the properties of ionic, covalent, and metallic substances, such as melting point, hardness, electrical conductivity, and thermal conductivity.",
      "Use models and labeled diagrams to represent the double helix structure of DNA (deoxyribonucleic acid).",
      "Explain the role of DNA, genes, and chromosomes in the transmission of traits.",
      "Describe mutations as changes in DNA or chromosomes.",
      "Explain some of the factors that cause mutations, such as infectious agents, radiation, and chemicals.",
      "Explain the advantage of high biodiversity in maintaining the stability of an ecosystem during difficult conditions, such as food shortages, disease, and climate change.",
      "Use information from secondary sources to research how to protect and conserve endangered and/or economically important species in the local community.",
      "Use information from secondary sources to describe the possible effects of human activities, such as deforestation, pollution, and the introduction of invasive species, on living things in an ecosystem.",
      "Describe, using labeled diagrams, the biotic and abiotic features of tropical rainforests, swamps, estuaries, mangrove forests, and coral reefs.",
      "Identify inertia as the tendency for an object to stay at rest or in motion unless acted on by an unbalanced net force.",
      "Demonstrate in practical situations and describe that acceleration is a change in speed and/or direction as the result of a net force.",
      "Investigate the relationship among force, acceleration, and mass.",
      "Explain that when any two objects interact, there are equal but opposite forces exerted between them, which is evident in many practical situations and applications.",
      "Observe and identify action-reaction pairs in everyday situations, such as stepping off a boat or a book on a table, and draw force diagrams to explain how the pairs affect the motion of objects.",
      "Identify that electricity is a flow of electrons and show appreciation for the need to observe safe measures in handling electricity.",
      "Infer the relationship among current, voltage, and resistance in assembled series and parallel circuits with varying numbers of loads and batteries.",
      "Recognize the advantages and limitations of using series or parallel circuits.",
      "Describe electromagnetic radiation (EMR) as energy created by the vibrations of electrically charged particles, allowing it to travel through materials or space as transverse waves.",
      "Compare the relative wavelengths and frequencies of different types of electromagnetic waves, including radio waves, microwaves, infrared, visible light, ultraviolet, X-rays, and gamma radiation.",
      "Identify practical applications of electromagnetic radiation, such as radio waves used in telecommunications and X-rays and gamma rays used in medicine.",
      "Gather information from secondary sources to explain the harmful effects that electromagnetic radiation can have on living things.",
      "Identify and explain evidence that current continents are separate parts of what was once a single continent millions of years ago.",
      "Examine and describe the topographical and geological evidence for plate boundaries occurring in the area where the Philippines is located.",
      "Describe the types of plate boundaries found around the Earth.",
      "Describe how fossils can be used for dating the age of rocks and sediments.",
      "Describe how relative and absolute dating techniques are used to determine the subdivisions of geologic time.",
      "Explain how the geologic time scale helps recount the history of the Earth.",
      "Describe how seismic wave data have been used to develop a model for the internal structure and composition of the Earth.",
      "Distinguish among comets, meteoroids, asteroids, and dwarf planets.",
      "Describe how comets, meteoroids, asteroids, and dwarf planets help us understand the nature and formation of the Earth and the Solar System.",
      "Explain how modern research about celestial objects uses new space technologies, including telescopes and space probes.",
      "Identify the number of valence electrons of oxygen based on its position in the periodic table.",
      "Explain the formation of ions as either the loss or gain of electrons to produce ionic bonds, using examples such as the formation of sodium chloride.",
      "Write the chemical formula and chemical names of common ionic compounds, including sodium chloride (NaCl), magnesium oxide (MgO), potassium chloride (KCl), and magnesium chloride (MgCl₂).",
      "Write the chemical formula and chemical names of common covalent compounds, including water (H₂O), carbon dioxide (CO₂), and ammonia (NH₃)."
   ])
};

export const MTG10ENGLISH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_literary_texts_poetry_prose_drama_film",
         "label": "Literary Text: Poetry, Prose, Drama, and Film (World Literature)",
         "start": 1,
         "count": 10,
         "mean": 8.333333333,
         "stdDev": 1.1,
         "ranges": [
            [0, 8.05, "Beginner"],
            [8.06, 8.88, "Basic"],
            [8.89, 10, "Competent"]
         ]
      },
      {
         "key": "b_informational_text_documentaries_vlogs",
         "label": "Informational Text: Documentaries and Vlogs",
         "start": 11,
         "count": 12,
         "mean": 7.888888889,
         "stdDev": 1.5,
         "ranges": [
            [0, 7.50, "Beginner"],
            [7.51, 10.39, "Basic"],
            [10.4, 12, "Competent"]
         ]
      },
      {
         "key": "c_transactional_text_evaluating_letters_for_clarity_of_purpose_and_meaning",
         "label": "Transactional Text: Evaluating letters for clarity of purpose and meaning",
         "start": 23,
         "count": 8,
         "mean": 6.755555556,
         "stdDev": 1.2,
         "ranges": [
            [0, 6.45, "Beginner"],
            [6.46, 6.96, "Basic"],
            [6.97, 8, "Competent"]
         ]
      },
      {
         "key": "d_research_report_based_on_literature_review",
         "label": "Research Report based on Literature review",
         "start": 31,
         "count": 15,
         "mean": 8.711111111,
         "stdDev": 2.2,
         "ranges": [
            [0, 8.15, "Beginner"],
            [8.16, 1.62, "Basic"],
            [11.91, 15, "Competent"]
         ]
      }
   ],
   totalRanges: [[0, 30.40, "Beginner"], [30.41, 37.80, "Basic"], [37.81, 45, "Competent"]],
   totalSummary: {"count":45, "mean":31.688888889, "stdDev":5.10819949},
   sections: [
      {
         "label": "Literary Text: Poetry, Prose, Drama, and Film (World Literature)",
         "start": 1,
         "end": 10
      },
      {
         "label": "Informational Text: Documentaries and Vlogs",
         "start": 11,
         "end": 22
      },
      {
         "label": "Transactional Text: Evaluating letters for clarity of purpose and meaning",
         "start": 23,
         "end": 30
      },
      {
         "label": "Research Report based on Literature review",
         "start": 31,
         "end": 45
      }
   ],
   competencies: toCompetencies([
      "Analyze literary texts as expressions of individual or communal values within the structural context of conflict: Character vs Society.",
      "Analyze literary texts as expressions of individual or communal values within the structural context of spectacle, dialogue, and music.",
      "Analyze literary texts as expressions of individual or communal values within the structural context of rhyme and meter.",
      "Analyze literary texts as expressions of individual or communal values within the structural context of diction.",
      "Analyze literary texts as expressions of individual or communal values within the structural context of tone and mood.",
      "Analyze literary texts as expressions of individual or communal values within the structural context of style.",
      "Analyze literary texts as expressions of individual or communal values within the structural context of patterns and motifs.",
      "Analyze literary texts as expressions of individual or communal values within the structural context of figures of speech and sound devices.",
      "Analyze the maxims, universal truths, and philosophies presented in the literary text as a means of valuing other people and their various circumstances in life.",
      "Identify one’s meaning and purpose in selecting the type of literary text for composition.",
      "Examine text structures for clarity of meaning and purpose in journalistic texts: documentaries and vlogs.",
      "Examine linguistic features as tools to achieve organizational efficiency in informational texts: transition devices.",
      "Examine linguistic features as tools to achieve organizational efficiency in informational texts: sentence structure and function.",
      "Examine how visual elements are used as tools to achieve the intended meaning of informational texts: vectors (for scientific, mathematical, or technical topics) and viewpoint, technical editing, animation.",
      "Analyze the real-world issues/occurrences presented in informational texts.",
      "Draw inferences and conclusions to formulate sound judgment: author’s purpose and meaning.",
      "Determine the veracity of the information presented: credibility of the author.",
      "Determine the veracity of the information presented: accuracy of information.",
      "Analyze textual evidence to support an argument/general statement: quoting.",
      "Assess the quality of journalistic articles based on standard development principles: objectivity and factuality.",
      "Assess the quality of journalistic articles based on standard development principles: fairness and balance.",
      "Determine one’s thesis as the central idea of the paper.",
      "Analyze distinguishing features of informal and formal correspondences to infer sender’s meaning and purpose across modalities: letter of application.",
      "Analyze milieus influencing the structure and rhetoric of informal and formal correspondences across modalities: organizational patterns.",
      "Analyze milieus influencing the structure and rhetoric of informal and formal correspondences across modalities: politeness strategies (etiquette).",
      "Examine the sender’s voice for clarity of purpose and meaning: style.",
      "Examine the sender’s voice for clarity of purpose and meaning: tone and register.",
      "Examine how ethics is established in transmitting informal and formal correspondences across modalities.",
      "Identify one’s purpose and meaning in writing letters.",
      "Send correspondences to communicate with and respond to senders within the bounds of ethics.",
      "Examine text structures for clarity of meaning and purpose in academic texts: research report.",
      "Examine linguistic features as tools to achieve organizational efficiency in informational texts: transition devices.",
      "Analyze the use of discipline-specific words, voice, technical terms in research, and conceptual, operational, and expanded definition of words.",
      "Analyze the use of discipline-specific words, voice, technical terms in research, and conceptual, operational, and expanded definition of words.",
      "Extract significant information.",
      "Analyze supporting evidence to validate assertions and counterclaims: statistical inference.",
      "Analyze supporting evidence to validate assertions and counterclaims: factual knowledge.",
      "Analyze supporting evidence to validate assertions and counterclaims: statistical inferences.",
      "Draw inferences and conclusions to formulate sound judgment: target audience – experts vs laypeople.",
      "Analyze textual evidence to support an argument/general statement: paraphrasing.",
      "Analyze textual evidence to support an argument/general statement: summarizing.",
      "Synthesize significant information.",
      "Organize significant information using various techniques.",
      "Determine one’s thesis as the central idea of the paper.",
      "Revise the text for coherence"
   ])
};

export const MTG10MATH_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_measurement_and_geometry",
         "label": "Measurement and Geometry",
         "start": 1,
         "count": 20,
         "mean": 9.422222222,
         "stdDev": 2.378778228,
         "ranges": [
            [0, 8.82, "Beginner"],
            [8.83, 12.80, "Basic"],
            [12.81, 20, "Competent"]
         ]
      },
      {
         "key": "b_number_and_algebra",
         "label": "Number and Algebra",
         "start": 21,
         "count": 21,
         "mean": 9.066666667,
         "stdDev": 1.082393728,
         "ranges": [
            [0, 8.79, "Beginner"],
            [8.8, 11.15, "Basic"],
            [11.16, 21, "Competent"]
         ]
      },
      {
         "key": "c_data_and_probability",
         "label": "Data and Probability",
         "start": 42,
         "count": 9,
         "mean": 4,
         "stdDev": 1.381698559,
         "ranges": [
            [0, 3.64, "Beginner"],
            [3.65, 6.38, "Basic"],
            [6.39, 9, "Competent"]
         ]
      }
   ],
   totalRanges: [[0, 20.40, "Beginner"], [20.41, 40.79, "Basic"], [40.8, 50,"Competent"]],
   totalSummary: {"count":50, "mean":21.488888889, "stdDev":4.299165999},
   sections: [
      {
         "label": "A. Measurement and Geometry",
         "start": 1,
         "end": 20
      },
      {
         "label": "B. Number and Algebra",
         "start": 21,
         "end": 41
      },
      {
         "label": "C. Data and probability",
         "start": 42,
         "end": 50
      }
   ],
   competencies: toCompetencies([
      "Apply laws of sines in solving oblique triangles, including ambiguous cases.",
      "Apply laws of cosines in solving oblique triangles.",
      "Describe the position of points in the Cartesian plane.",
      "Describe translations, reflections, and rotations, in the Cartesian plane using coordinates.",
      "Solve problems involving laws of sines and cosines, including bearings.",
      "Illustrate on the number line quadratic inequalities in one variable.",
      "Solve quadratic inequalities in one variable and express solutions in various notations.",
      "Solve quadratic inequalities in two variables.",
      "Determine the center and the radius of a circle from a given equation.",
      "Find the equation of a circle from given conditions, e.g., given two points as the endpoints of a diameter.",
      "Solve problems involving geometric figures on the Cartesian plane.",
      "Establish properties and relationships for central angles, inscribed angles, secants, and tangents of a circle.",
      "Solve problems involving inscribed angles.",
      "Solve problems involving angles formed by two intersecting chords.",
      "Solve problems involving angles formed by two secants intersecting outside the circle.",
      "Establish properties and relationships for chords, secants, and tangents.",
      "Solve problems involving lengths of two secant segments intersecting outside a circle.",
      "Solve problems involving lengths of two intersecting tangent segments.",
      "Define sectors and segments of a circle and find their areas.",
      "Solve problems involving area of a sector of a circle, segment of a circle, and shaded regions in other figures that involve sectors or segments.",
      "Determine the region of solutions of a linear or quadratic inequality in two variables.",
      "Solve absolute value equations in one variable and express solutions in various notations.",
      "Solve absolute value inequalities in one variable and express solutions in various notations.",
      "Illustrate the laws of rational non-integral exponents.",
      "Simplify radical expressions.",
      "Perform operations involving radical expressions, including rationalizing the denominator.",
      "Determine the nature of roots of a quadratic equation using the discriminant.",
      "Determine the equation of a quadratic function given its graph.",
      "Determine the equation of a quadratic function given its zeros.",
      "Solve equations reducible to quadratic equations, e.g., x⁴ + 5x² + 4 = 0.",
      "Solve problems involving quadratic functions.",
      "Solve radical equations, including equations reducible to linear or quadratic equations.",
      "Transform the equation of a circle from center-radius form to general form, and vice versa.",
      "Illustrate union and intersection of events, including mutually and non-mutually exclusive events.",
      "Illustrate dependent and independent events, including conditional probability where the solution is limited to the use of contingency tables or Venn diagrams.",
      "Explore inductively the relationship between simple interest and compound interest.",
      "Calculate compound interest by repeated applications of simple interest.",
      "Solve problems involving compound interest by repeated applications of simple interest.",
      "Explain inductively the formulas for compound interest and depreciation.",
      "Explore inductively the differences in the amount of compound interest obtained on amounts of money invested annually, quarterly, and monthly.",
      "Solve real-life problems involving compound interest.",
      "Illustrate measures of position (quartiles, deciles, and percentiles).",
      "Construct and interpret box-and-whisker plots and cumulative frequency histograms and polygons.",
      "Calculate a specified measure of position, interquartile range, and outliers, from ungrouped data.",
      "Calculate the percentile rank of a given score from ungrouped data.",
      "Draw conclusions from statistical data using the measures of position.",
      "Evaluate statistical reports by linking claims to displays, statistics, and representative data.",
      "Illustrate mutually exclusive events and non-mutually exclusive events.",
      "Identify complementary events.",
      "Solve probability problems involving complementary events."
   ])
};

export const MTG10SCIENCE_SUBJECT_CONFIG = {
   individualApiVersion: 3,
   summaryApiVersion: 3,
   summaryAreas: [
      {
         "key": "a_matter",
         "label": "Matter",
         "start": 1,
         "count": 9,
         "mean": 3.955555556,
         "stdDev": 1.566054039,
         "ranges": [
            [0, 3.55, "Beginner"],
            [3.56, 6.52, "Basic"],
            [6.53, 9, "Competent"]
         ]
      },
      {
         "key": "b_living_things",
         "label": "Living Things",
         "start": 10,
         "count": 10,
         "mean": 6.8,
         "stdDev": 2.231998697,
         "ranges": [
            [0, 6.23, "Beginner"],
            [6.24, 8.03, "Basic"],
            [8.04, 10, "Competent"]
         ]
      },
      {
         "key": "c_earth_and_space",
         "label": "Earth and Space",
         "start": 20,
         "count": 12,
         "mean": 9.822222222,
         "stdDev": 2.870610395,
         "ranges": [
            [0, 9.09, "Beginner"],
            [9.09, 10.69, "Basic"],
            [10.7, 12, "Competent"]
         ]
      },
      {
         "key": "d_force_motion_and_energy",
         "label": "Force, Motion, and Energy",
         "start": 32,
         "count": 14,
         "mean": 10.155555556,
         "stdDev": 3.081879264,
         "ranges": [
            [0, 9.38, "Beginner"],
            [9.39, 12.24, "Basic"],
            [12.25, 14, "Competent"]
         ]
      }
   ],
   totalRanges: [[0, 28.76, "Beginner"], [28.77, 40.59, "Basic"], [40.6, 45, "Competent"]],
   totalSummary: {"count":45, "mean":30.733333333, "stdDev":7.857827597},
   sections: [
      {
         "label": "Matter",
         "start": 1,
         "end": 9
      },
      {
         "label": "Living Things",
         "start": 10,
         "end": 19
      },
      {
         "label": "Earth and Space",
         "start": 20,
         "end": 31
      },
      {
         "label": "Force, Motion, and Energy",
         "start": 32,
         "end": 45
      }
   ],
   competencies: toCompetencies([
      "Describe the indicators for a chemical reaction as color change, the formation of a precipitate, the release of gas, and/or odor, or a change in temperature.",
      "Identify common acids, bases, and salts (e.g., hydrochloric acid, sodium hydroxide, and saline solution) using different indicators.",
      "Describe important types of chemical reactions (combination, decomposition, single replacement, double replacement).",
      "Explain how important types of chemical reactions, such as combustion, acids on metals, acids on carbonates, photosynthesis, and respiration, relate to or impact the natural and built environments using information from secondary sources.",
      "Recognize that scientists: a. use chemical equations to describe chemical reactions, and b. write equations in word form and use formulas for common chemical reactions.",
      "Explain that chemical equations demonstrate a rearrangement of atoms but the total mass of the system remains the same during a chemical reaction.",
      "Apply the principles of conservation of mass to balance chemical equations.",
      "Explain the factors affecting the rates of chemical reactions as applied in food preservation and materials production, control of fire, pollution, and corrosion.",
      "Identify that chemical reactions may be exothermic or endothermic.",
      "Describe homeostasis as a state of balance among all the body systems in humans that needs to be maintained for survival and proper functioning; its indicators include body temperature, glucose level, and blood pressure.",
      "Explain how homeostasis is maintained through various feedback mechanisms, both positive and negative.",
      "Use information from secondary sources to describe natural selection as the primary mechanism driving evolutionary change.",
      "Discuss in small groups important concepts in the theories of evolution, such as variation, heredity, isolation, selection, and adaptation.",
      "Use information from secondary sources to explain how lines of evidence such as fossils, biogeography, and comparative morphology support the occurrence of evolution.",
      "Discuss the factors that limit the ecosystem's carrying capacity, such as adequate food, shelter, water, and mates.",
      "Explain that the ecosystem's population growth slows down as it gets closer to the carrying capacity.",
      "Use information from secondary sources to identify the products of traditional biotechnology through fermentation (e.g., cheese, soy sauce, vinegar, nata de coco).",
      "Use information from secondary sources to identify examples of modern biotechnology, such as genetically modified organisms and processes (e.g., in vitro fertilization).",
      "Participate in a class debate on the societal, environmental, and ethical implications of using biotechnological products and methods.",
      "Identify modern scientific processes used to detect and measure the displacement of tectonic plates.",
      "Describe the structures, movements, and events that occur at each type of plate boundary.",
      "Identify the locations of major mountains, faults, volcanoes, and ocean trenches using a map of the Philippine Archipelago, and interpret the features in relation to plate tectonics.",
      "Predict the position and shape of the Philippine Archipelago in 50 million years, based on the current velocity of the Philippine Plate.",
      "Gather information from secondary sources to describe and explain what mechanisms drive the movement of tectonic plates including the role of the asthenosphere.",
      "Explain how the subduction of an oceanic plate impacts on the plate above it.",
      "Explain how plate tectonics can be used to explain the formation of the largest mountain ranges on Earth including the Himalayas and the Andes mountains.",
      "Identify evidence of global warming and climate change.",
      "Identify the role of greenhouse gases in enhanced global warming and climate change.",
      "Describe how global climatic phenomena, such as the El Niño Southern Oscillation, may impact weather systems.",
      "Identify local impacts of global climate change and suggest ways that individuals can do to reduce the impact of global warming.",
      "Explain how increased societal uses of renewable energies could mitigate the effects of global climate change, including how the Philippines could make better use of its plentiful natural resources.",
      "Investigate and describe the relationship among the projectile variables including the angle and velocity of release, and projectile height and range, using everyday activities such as shooting basketballs or kicking footballs.",
      "Describe different types of collisions as elastic or inelastic by providing some examples.",
      "Use models to investigate elastic or inelastic collisions and describe the forces involved and their effects.",
      "Explain that momentum depends on the mass and the velocity of a moving object that can be used to predict the impact the object will have if it hits another object.",
      "Carry out guided investigations using different objects to describe momentum-related relationships, such as the more momentum an object has, the harder for it to stop.",
      "Identify and explain that to change the momentum of an object, it is necessary to apply a force on the object over a period of time.",
      "Gather information from secondary sources to identify ways to reduce the impact of collisions such as seatbelts, airbags, and crumple zones in vehicles.",
      "Identify that momentum is conserved before and after the collision of objects.",
      "Describe how high voltage electricity from power plants is generated and safely distributed to industries, businesses, and homes, including the role of substations (grid stations), and electric meters.",
      "Describe how high voltage electricity from power plants is generated and safely distributed to industries, businesses, and homes, including the role of substations (grid stations), and electric meters.",
      "Describe and explain the need for safety precautions in handling household electrical devices.",
      "Describe the similarities and differences between electric motors and electric generators.",
      "Collaborate in a class discussion to identify ways to reduce the use of electrical energy in Filipino houses and communities and explain what local and global benefits can be achieved.",
      "Gather information from secondary sources to evaluate how renewable and nonrenewable generation of electricity in the Philippines impacts human activities and the environment."
   ])
};
